import * as React from 'react';
import React__default, { createContext, useContext, useMemo, useEffect } from 'react';
import { useIntl, useFeatureToggles, useApiConfig, Currencies } from '@grandvisionhq/state';
import { toast, Button, Alert, IconButton, Price, MediaQuery, LineItemDeleteButton, QuantitySelector, LineItem, LineItemMedia, LineItemContent, LineItemGlassesPrescription, PrescriptionGlassesBundleChildItem, Loader as Loader$1, StickyCallToAction, LineItemAside, Modal, RadioButton, PriceTag } from '@grandvisionhq/common';
import { gql, makeVar, useLazyQuery, useMutation, useReactiveVar } from '@grandvisionhq/graphql';
import { getAttrValue, isNumber, isString, isValidImages, getFrontImage, isPlainObject, getLocalizedValue, DateUtils, isBoolean, getLocalizedAttrValue, isArray, useLocalStorage, useEventListener, isNotNull, isNil, isFunction } from '@grandvisionhq/utils';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { calcPrice as calcPrice$1, DataLayer, CartV2Actions } from '@grandvisionhq/analytics';
import { Heading, Text, Divider } from '@grandvisionhq/elements';
import classnames from 'classnames';
import { DeliveryIndicator, StockIndicator, Helpers } from '@grandvisionhq/inventory';
import { Icon } from '@grandvisionhq/icons';
import { DiscountCodeForm } from '@grandvisionhq/forms';
import { useInView } from 'react-intersection-observer';
import { useApiClient, Products } from '@grandvisionhq/api-client';

var CartContext = React.createContext(null);
CartContext.displayName = 'CartContext';
var useCart = function () {
    var context = React.useContext(CartContext);
    if (!context) {
        throw new Error('No Cart available. You might still need to wrap the application with the CartProvider component.');
    }
    return context;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var CartSettingsContext = createContext(null);
CartSettingsContext.displayName = 'CartSettings';
var useCartSettings = function () {
    var context = useContext(CartSettingsContext);
    if (context === null) {
        throw new Error('Missing CartSettings provider. You have to wrap the application with the CartSettingsProvider component from the @grandvisionhq/carts-v2 package.');
    }
    return context;
};

var defaultSettings = {
    allowBackOrder: true,
    hideStockAndDeliveryOnLineItem: false,
    multiDiscountType: false,
    showSubTotal: true,
    showTotalDiscount: true,
    showCartDiscountDescriptions: true,
    isDiscountCodeEnabled: false,
};
var CartSettingsProvider = function (_a) {
    var children = _a.children, settings = _a.settings;
    var value = React.useMemo(function () { return (__assign(__assign({}, defaultSettings), settings)); }, [settings]);
    return React.createElement(CartSettingsContext.Provider, { value: value }, children);
};

var address = gql(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  fragment AddressFragment on CartAddress {\n    additionalStreetInfo\n    apartment\n    building\n    city\n    company\n    countryCode\n    department\n    email\n    externalId\n    firstName\n    key\n    lastName\n    mobile\n    phone\n    pOBox\n    postalCode\n    region\n    salutation\n    streetName\n    streetNumber\n    title\n  }\n"], ["\n  fragment AddressFragment on CartAddress {\n    additionalStreetInfo\n    apartment\n    building\n    city\n    company\n    countryCode\n    department\n    email\n    externalId\n    firstName\n    key\n    lastName\n    mobile\n    phone\n    pOBox\n    postalCode\n    region\n    salutation\n    streetName\n    streetNumber\n    title\n  }\n"])));
var templateObject_1$k;

var discount = gql(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  fragment DiscountFragment on Discount {\n    id\n    isActive\n    key\n    name {\n      locale\n      value\n      __typename\n    }\n    description {\n      locale\n      value\n    }\n    type\n    value {\n      centAmount\n      percentage\n      scale\n      type\n      __typename\n    }\n    validFrom\n    validUntil\n    __typename\n  }\n"], ["\n  fragment DiscountFragment on Discount {\n    id\n    isActive\n    key\n    name {\n      locale\n      value\n      __typename\n    }\n    description {\n      locale\n      value\n    }\n    type\n    value {\n      centAmount\n      percentage\n      scale\n      type\n      __typename\n    }\n    validFrom\n    validUntil\n    __typename\n  }\n"])));
var templateObject_1$j;

var legacyProduct = gql(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  fragment LegacyProductFragment on LegacyProduct {\n    id\n    sku\n    productType\n    masterData {\n      current {\n        variant {\n          availability {\n            channels {\n              key\n              value {\n                isOnStock\n                availableQuantity\n              }\n            }\n          }\n          attributes {\n            name\n            value\n          }\n          images {\n            url\n          }\n          media {\n            images {\n              url\n              label\n            }\n          }\n          sku\n        }\n        name {\n          value\n          locale\n        }\n        slug {\n          value\n          locale\n        }\n      }\n    }\n  }\n"], ["\n  fragment LegacyProductFragment on LegacyProduct {\n    id\n    sku\n    productType\n    masterData {\n      current {\n        variant {\n          availability {\n            channels {\n              key\n              value {\n                isOnStock\n                availableQuantity\n              }\n            }\n          }\n          attributes {\n            name\n            value\n          }\n          images {\n            url\n          }\n          media {\n            images {\n              url\n              label\n            }\n          }\n          sku\n        }\n        name {\n          value\n          locale\n        }\n        slug {\n          value\n          locale\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$i;

var lineItemPrice = gql(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  fragment LineItemPriceFragment on LineItemPrice {\n    total {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    unit {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n"], ["\n  fragment LineItemPriceFragment on LineItemPrice {\n    total {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    unit {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    __typename\n  }\n"])));
var templateObject_1$h;

var lineItemBundle = gql(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  fragment LineItemBundleFragment on LineItemBundle {\n    id\n    sku\n    lineItemType\n    bundleLineItemsType\n    bundleLineItems {\n      sku\n      type\n      isMainBundleLineItem\n      quantity\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      legacyProduct {\n        ...LegacyProductFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment LineItemBundleFragment on LineItemBundle {\n    id\n    sku\n    lineItemType\n    bundleLineItemsType\n    bundleLineItems {\n      sku\n      type\n      isMainBundleLineItem\n      quantity\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      legacyProduct {\n        ...LegacyProductFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), legacyProduct, lineItemPrice, discount);
var templateObject_1$g;

var contactLensBundleBeneluxTypeDetails = gql(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  fragment ContactLensBundleBeneluxTypeDetailsFragment on ContactLensBundleBeneluxTypeDetails {\n    prescription {\n      rightLens {\n        baseCurve\n        diameter\n        power\n        axis\n        cylinder\n      }\n      leftLens {\n        baseCurve\n        diameter\n        power\n        axis\n        cylinder\n      }\n    }\n  }\n"], ["\n  fragment ContactLensBundleBeneluxTypeDetailsFragment on ContactLensBundleBeneluxTypeDetails {\n    prescription {\n      rightLens {\n        baseCurve\n        diameter\n        power\n        axis\n        cylinder\n      }\n      leftLens {\n        baseCurve\n        diameter\n        power\n        axis\n        cylinder\n      }\n    }\n  }\n"])));
var templateObject_1$f;

var contactLensSubscriptionTypeDetails = gql(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  fragment ContactLensSubscriptionTypeDetailsFragment on ContactLensSubscriptionTypeDetails {\n    billingFrequency\n    deliveryFrequency\n    prescriptionForSubscription {\n      leftLens {\n        axis\n        baseCurve\n        cylinder\n        diameter\n        power\n      }\n      rightLens {\n        axis\n        baseCurve\n        cylinder\n        diameter\n        power\n      }\n    }\n    subscriptionPromotion {\n      code\n      localizedTexts {\n        locale\n        value\n      }\n    }\n  }\n"], ["\n  fragment ContactLensSubscriptionTypeDetailsFragment on ContactLensSubscriptionTypeDetails {\n    billingFrequency\n    deliveryFrequency\n    prescriptionForSubscription {\n      leftLens {\n        axis\n        baseCurve\n        cylinder\n        diameter\n        power\n      }\n      rightLens {\n        axis\n        baseCurve\n        cylinder\n        diameter\n        power\n      }\n    }\n    subscriptionPromotion {\n      code\n      localizedTexts {\n        locale\n        value\n      }\n    }\n  }\n"])));
var templateObject_1$e;

var contactLensesTypeDetails = gql(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  fragment ContactLensesTypeDetailsFragment on ContactLensesTypeDetails {\n    eyeSide\n    __typename\n  }\n"], ["\n  fragment ContactLensesTypeDetailsFragment on ContactLensesTypeDetails {\n    eyeSide\n    __typename\n  }\n"])));
var templateObject_1$d;

var eyePrescription = gql(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  fragment EyePrescriptionFragment on SingleEyePrescription {\n    baseCurve\n    diameter\n    power\n    axis\n    cylinder\n    addition\n    pupillaryDistance\n  }\n"], ["\n  fragment EyePrescriptionFragment on SingleEyePrescription {\n    baseCurve\n    diameter\n    power\n    axis\n    cylinder\n    addition\n    pupillaryDistance\n  }\n"])));
var templateObject_1$c;

var prescriptionGlassesTypeDetails = gql(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  fragment PrescriptionGlassesTypeDetailsFragment on BundlePrescriptionGlassesTypeDetails {\n    newPrescription {\n      leftLens {\n        ...EyePrescriptionFragment\n      }\n      rightLens {\n        ...EyePrescriptionFragment\n      }\n      opticianDetails {\n        type\n        opticianName\n        postalCode\n        city\n        country\n        address\n        streetName\n        additionalStreetInfo\n        additionalAddressInfo\n        region\n      }\n      examDate\n      expiryDate\n    }\n    prescriptionFile {\n      fileName\n      storageId\n      __typename\n    }\n    pupillaryDistanceFile {\n      fileName\n      storageId\n      __typename\n    }\n    isEmailPrescription\n    isExistingCustomer\n  }\n  ", "\n"], ["\n  fragment PrescriptionGlassesTypeDetailsFragment on BundlePrescriptionGlassesTypeDetails {\n    newPrescription {\n      leftLens {\n        ...EyePrescriptionFragment\n      }\n      rightLens {\n        ...EyePrescriptionFragment\n      }\n      opticianDetails {\n        type\n        opticianName\n        postalCode\n        city\n        country\n        address\n        streetName\n        additionalStreetInfo\n        additionalAddressInfo\n        region\n      }\n      examDate\n      expiryDate\n    }\n    prescriptionFile {\n      fileName\n      storageId\n      __typename\n    }\n    pupillaryDistanceFile {\n      fileName\n      storageId\n      __typename\n    }\n    isEmailPrescription\n    isExistingCustomer\n  }\n  ", "\n"])), eyePrescription);
var templateObject_1$b;

var cartDetails = gql(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  fragment CartDetailsFragment on Cart {\n    __typename\n    id\n    customerDetails {\n      email\n      phone\n      customerType\n      dateOfBirth\n    }\n    invoiceDetails {\n      certifiedEmail\n      vatId\n      certifiedRecipientCode\n    }\n    shippingAddress {\n      ...AddressFragment\n    }\n    shippingMethod {\n      id\n      key\n    }\n    billingAddress {\n      ...AddressFragment\n    }\n    appliedDiscounts {\n      name {\n        locale\n        value\n        __typename\n      }\n      requiresDiscountCode\n      __typename\n    }\n    numberOfItems\n    price {\n      subtotal\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      net\n      gross\n      tax {\n        amount\n        portions {\n          rate\n          amount\n          __typename\n        }\n        __typename\n      }\n      shippingPrice\n      paymentMethodPrice\n      subscriptionPlanPrice {\n        __typename\n        invoicedAmount\n        total\n      }\n      __typename\n    }\n    vouchers {\n      code\n      isActive\n      name\n      state\n      __typename\n    }\n    subscriptionPlan {\n      billingDate\n      __typename\n    }\n    isAccountRequired\n    lineItems {\n      id\n      lineItemType\n      typeDetails {\n        ... on ContactLensBundleBeneluxTypeDetails {\n          ...ContactLensBundleBeneluxTypeDetailsFragment\n        }\n        ... on ContactLensSubscriptionTypeDetails {\n          ...ContactLensSubscriptionTypeDetailsFragment\n        }\n        ... on ContactLensesTypeDetails {\n          ...ContactLensesTypeDetailsFragment\n        }\n        ... on BundlePrescriptionGlassesTypeDetails {\n          ...PrescriptionGlassesTypeDetailsFragment\n        }\n      }\n      isGift\n      sku\n      quantity\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      __typename\n      ... on LineItemRegular {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemContactLenses {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemBundle {\n        ...LineItemBundleFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment CartDetailsFragment on Cart {\n    __typename\n    id\n    customerDetails {\n      email\n      phone\n      customerType\n      dateOfBirth\n    }\n    invoiceDetails {\n      certifiedEmail\n      vatId\n      certifiedRecipientCode\n    }\n    shippingAddress {\n      ...AddressFragment\n    }\n    shippingMethod {\n      id\n      key\n    }\n    billingAddress {\n      ...AddressFragment\n    }\n    appliedDiscounts {\n      name {\n        locale\n        value\n        __typename\n      }\n      requiresDiscountCode\n      __typename\n    }\n    numberOfItems\n    price {\n      subtotal\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      net\n      gross\n      tax {\n        amount\n        portions {\n          rate\n          amount\n          __typename\n        }\n        __typename\n      }\n      shippingPrice\n      paymentMethodPrice\n      subscriptionPlanPrice {\n        __typename\n        invoicedAmount\n        total\n      }\n      __typename\n    }\n    vouchers {\n      code\n      isActive\n      name\n      state\n      __typename\n    }\n    subscriptionPlan {\n      billingDate\n      __typename\n    }\n    isAccountRequired\n    lineItems {\n      id\n      lineItemType\n      typeDetails {\n        ... on ContactLensBundleBeneluxTypeDetails {\n          ...ContactLensBundleBeneluxTypeDetailsFragment\n        }\n        ... on ContactLensSubscriptionTypeDetails {\n          ...ContactLensSubscriptionTypeDetailsFragment\n        }\n        ... on ContactLensesTypeDetails {\n          ...ContactLensesTypeDetailsFragment\n        }\n        ... on BundlePrescriptionGlassesTypeDetails {\n          ...PrescriptionGlassesTypeDetailsFragment\n        }\n      }\n      isGift\n      sku\n      quantity\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      __typename\n      ... on LineItemRegular {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemContactLenses {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemBundle {\n        ...LineItemBundleFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), address, contactLensBundleBeneluxTypeDetails, contactLensSubscriptionTypeDetails, contactLensesTypeDetails, prescriptionGlassesTypeDetails, legacyProduct, lineItemBundle, lineItemPrice, discount);
var templateObject_1$a;

var cartValidationErrors = gql(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  fragment CartValidationErrorsFragment on CartValidationErrors {\n    cartErrors {\n      defaultMessage\n      validationCode\n      passed\n    }\n    cartLineItemErrors {\n      errors {\n        defaultMessage\n        validationCode\n        passed\n      }\n      itemId\n    }\n  }\n"], ["\n  fragment CartValidationErrorsFragment on CartValidationErrors {\n    cartErrors {\n      defaultMessage\n      validationCode\n      passed\n    }\n    cartLineItemErrors {\n      errors {\n        defaultMessage\n        validationCode\n        passed\n      }\n      itemId\n    }\n  }\n"])));
var templateObject_1$9;

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cartDetails: cartDetails,
  cartValidationErrors: cartValidationErrors
});

var ADD_CART_LINE_ITEMS = gql(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  mutation AddCartLineItems($cartInput: AddCartLineItemsInput!) {\n    addCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation AddCartLineItems($cartInput: AddCartLineItemsInput!) {\n    addCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$8;

var ADD_CART_VOUCHER_CODES = gql(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  mutation AddCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    addCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation AddCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    addCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$7;

var CREATE_CART = gql(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  mutation CreateCart($cartInput: CreateCartInput!) {\n    createCart(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation CreateCart($cartInput: CreateCartInput!) {\n    createCart(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$6;

var REMOVE_CART_VOUCHER_CODES = gql(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  mutation RemoveCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    removeCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation RemoveCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    removeCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$5;

var REMOVE_CART_LINE_ITEMS = gql(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  mutation RemoveCartLineItems($cartInput: RemoveCartLineItemsInput!) {\n    removeCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation RemoveCartLineItems($cartInput: RemoveCartLineItemsInput!) {\n    removeCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$4;

var UPDATE_CART_LINE_ITEMS = gql(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  mutation UpdateCartLineItems($cartInput: UpdateCartLineItemsInput!) {\n    updateCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation UpdateCartLineItems($cartInput: UpdateCartLineItemsInput!) {\n    updateCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$3;

var REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM = gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  mutation ReplaceContactLensBundleBeneluxCartLineItem(\n    $cartInput: ReplaceCartContactLensBundleBeneluxLineItemInput!\n  ) {\n    replaceContactLensBundleBeneluxCartLineItem(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation ReplaceContactLensBundleBeneluxCartLineItem(\n    $cartInput: ReplaceCartContactLensBundleBeneluxLineItemInput!\n  ) {\n    replaceContactLensBundleBeneluxCartLineItem(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$2;

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ADD_CART_LINE_ITEMS: ADD_CART_LINE_ITEMS,
  ADD_CART_VOUCHER_CODES: ADD_CART_VOUCHER_CODES,
  CREATE_CART: CREATE_CART,
  REMOVE_CART_VOUCHER_CODES: REMOVE_CART_VOUCHER_CODES,
  REMOVE_CART_LINE_ITEMS: REMOVE_CART_LINE_ITEMS,
  UPDATE_CART_LINE_ITEMS: UPDATE_CART_LINE_ITEMS,
  REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM: REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM
});

var GET_CART = gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  query GetCart($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query GetCart($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$1;

var GET_TOTAL_LINE_ITEMS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetTotalLineItems($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        id\n        numberOfItems\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetTotalLineItems($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        id\n        numberOfItems\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n"])), cartValidationErrors);
var templateObject_1;

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GET_CART: GET_CART,
  GET_TOTAL_LINE_ITEMS: GET_TOTAL_LINE_ITEMS
});

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Fragments: index$6,
  Mutations: index$5,
  Queries: index$4
});

var cartCountVar = makeVar(0);

var getActiveVoucherCodes = function (vouchers) {
    if (!vouchers) {
        return;
    }
    return vouchers.filter(function (voucher) { return voucher.isActive; }).map(function (voucher) { return voucher.code; });
};

var areSameContactLenses = function (serverLineItem, draftLineItem) {
    var _a, _b, _c;
    if (draftLineItem.type !== 'contact-lenses' ||
        ((_a = serverLineItem.typeDetails) === null || _a === void 0 ? void 0 : _a.__typename) !== 'ContactLensesTypeDetails') {
        return false;
    }
    // A Contact Lens is only considered the same product when the eyeside matches as well
    return (serverLineItem.sku === draftLineItem.sku &&
        ((_b = serverLineItem.typeDetails) === null || _b === void 0 ? void 0 : _b.eyeSide) === ((_c = draftLineItem.typeDetails.eyeSide) === null || _c === void 0 ? void 0 : _c.toUpperCase()));
};

/**
 * Only returns true when both set a and b match exactly
 */
var isExactMatch = function (a, b) {
    var e_1, _a;
    var diff = new Set(a);
    try {
        for (var b_1 = __values(b), b_1_1 = b_1.next(); !b_1_1.done; b_1_1 = b_1.next()) {
            var elem = b_1_1.value;
            if (diff.has(elem)) {
                diff.delete(elem);
            }
            else {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (b_1_1 && !b_1_1.done && (_a = b_1.return)) _a.call(b_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return diff.size <= 0;
};
var isMissing = function (value) {
    return typeof value === 'undefined' ||
        value === null ||
        (typeof value === 'object' && Object.getOwnPropertyNames(value).length < 1);
};
/**
 * Server and client have a different way of expressing a missing value. With
 * this util we can easily catch this situation.
 */
function areBothMissing(server, client) {
    return isMissing(server) && isMissing(client);
}

var areSameOpticianDetails = function (server, draft) {
    var e_1, _a;
    var sameExpiryDate = areBothMissing(server.expiryDate, draft.expiryDate) || server.expiryDate === draft.expiryDate;
    var sameExamDate = areBothMissing(server.examDate, draft.examDate) || server.examDate === draft.examDate;
    var sameDates = sameExpiryDate && sameExamDate;
    if (!sameDates) {
        return false;
    }
    if (areBothMissing(draft.opticianDetails, server.opticianDetails)) {
        // If they're both missing we consider them equal
        return true;
    }
    else if (!draft.opticianDetails || !server.opticianDetails) {
        // If one of them is missing we consider them to not be equal
        return false;
    }
    try {
        for (var _b = __values(Object.getOwnPropertyNames(draft.opticianDetails)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var field = _c.value;
            var serverValue = server.opticianDetails[field];
            var draftValue = draft.opticianDetails[field];
            /**
             * If server and client both express in their own way that
             * the value is missing, we consider them to be equal.
             */
            if (areBothMissing(serverValue, draftValue)) {
                continue;
            }
            if (serverValue !== draftValue) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};

var opticalParametersOnServer = [
    'baseCurve',
    'diameter',
    'power',
    'axis',
    'cylinder',
    'addition',
    'pupillaryDistance',
];
var areSamePrescriptionParameters = function (server, draft) {
    var e_1, _a;
    var serverMap = new Map(Object.entries(server).filter(function (_a) {
        var _b = __read(_a, 1), k = _b[0];
        return k !== '__typename';
    }));
    try {
        for (var opticalParametersOnServer_1 = __values(opticalParametersOnServer), opticalParametersOnServer_1_1 = opticalParametersOnServer_1.next(); !opticalParametersOnServer_1_1.done; opticalParametersOnServer_1_1 = opticalParametersOnServer_1.next()) {
            var attributeName = opticalParametersOnServer_1_1.value;
            var serverValue = serverMap.get(attributeName);
            var draftValue = draft[attributeName];
            /**
             * If server and client both express in their own way that
             * the value is missing, we consider them to be equal.
             */
            if (areBothMissing(serverValue, draftValue)) {
                serverMap.delete(attributeName);
                continue;
            }
            if (serverValue !== draftValue) {
                return false;
            }
            serverMap.delete(attributeName);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (opticalParametersOnServer_1_1 && !opticalParametersOnServer_1_1.done && (_a = opticalParametersOnServer_1.return)) _a.call(opticalParametersOnServer_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return serverMap.size <= 0;
};

var isSamePrescription = function (server, draft) {
    if (server.isEmailPrescription) {
        return draft.type === 'email-prescription';
    }
    else if (server.isExistingCustomer) {
        return draft.type === 'existing-customer';
    }
    else if (server.prescriptionFile && server.pupillaryDistanceFile) {
        if (draft.type !== 'prescription-file') {
            return false;
        }
        return (draft.details.prescriptionFile.storageId === server.prescriptionFile.storageId &&
            draft.details.pupillaryDistanceFile.storageId === server.pupillaryDistanceFile.storageId);
    }
    if (draft.type !== 'new-prescription' || !server.newPrescription) {
        return false;
    }
    var _a = server.newPrescription, leftLens = _a.leftLens, rightLens = _a.rightLens, examDate = _a.examDate, expiryDate = _a.expiryDate, opticianDetails = _a.opticianDetails;
    return (areSamePrescriptionParameters(leftLens, draft.details.leftLens) &&
        areSamePrescriptionParameters(rightLens, draft.details.rightLens) &&
        areSameOpticianDetails({ examDate: examDate, expiryDate: expiryDate, opticianDetails: opticianDetails }, draft.details));
};

var areSamePrescriptionGlassesLineItem = function (serverLineItem, draftLineItem) {
    var _a;
    if (serverLineItem.__typename !== 'LineItemBundle') {
        return false;
    }
    if (((_a = serverLineItem.typeDetails) === null || _a === void 0 ? void 0 : _a.__typename) !== 'BundlePrescriptionGlassesTypeDetails') {
        return false;
    }
    var serverSkus = new Set(serverLineItem.bundleLineItems.map(function (bl) { return bl.legacyProduct.sku; }));
    var draftSkus = new Set(__spreadArray([draftLineItem.sku], __read(draftLineItem.bundleLineItems.map(function (b) { return b.sku; }))));
    return (isExactMatch(serverSkus, draftSkus) &&
        isSamePrescription(serverLineItem.typeDetails, draftLineItem.prescription));
};

var areSameRegularProduct = function (serverLineItem, draftLineItem) {
    if (serverLineItem.__typename !== 'LineItemRegular') {
        return false;
    }
    return serverLineItem.sku === draftLineItem.sku;
};

var sameProduct = function (serverLineItem, draft) {
    switch (draft.type) {
        case 'contact-lenses-bundle-benelux':
        case 'contact-lenses-subscription':
            return serverLineItem.sku === draft.sku;
        case 'regular':
            return areSameRegularProduct(serverLineItem, draft);
        case 'prescription-glasses':
            // A LineItemBundle is considered the same product only when all SKUs match exactly
            return areSamePrescriptionGlassesLineItem(serverLineItem, draft);
        case 'contact-lenses':
            // CL drafts should already be matched by the check above
            return areSameContactLenses(serverLineItem, draft);
    }
};
var getAddedLineItems = function (lineItemsInCart, newLineItems) {
    var lookup = newLineItems.reduce(function (m, lineItemDraft) {
        var _a;
        return __assign(__assign({}, m), (_a = {}, _a[lineItemDraft.sku] = lineItemDraft, _a));
    }, {});
    // First we get the relevant line items in full from the cart response, matched by SKU from the payload
    var addedLineItemsFromCartResponse = lineItemsInCart.filter(function (lineItem) { return lineItem.sku in lookup && sameProduct(lineItem, lookup[lineItem.sku]); });
    // We need quantity and total pricing based on the products that were just added, excluding eventual previously existing
    // products
    return addedLineItemsFromCartResponse.map(function (lineItem) {
        var _a;
        var draft = lookup[lineItem.sku];
        var quantity = (_a = draft === null || draft === void 0 ? void 0 : draft.quantity) !== null && _a !== void 0 ? _a : 1;
        if (lineItem.quantity === quantity) {
            return lineItem;
        }
        return __assign(__assign({}, lineItem), { quantity: quantity, price: getTotalPricePerAddedQuantity(lineItem.price, quantity) });
    });
};
// Overwrite total pricing based on unit price * quantity
var getTotalPricePerAddedQuantity = function (price, quantity) { return (__assign(__assign({}, price), { total: __assign(__assign({}, price.total), { gross: price.unit.gross * quantity, net: price.unit.net * quantity, subtotal: price.unit.subtotal * quantity, discount: __assign(__assign({}, price.total.discount), { amount: price.unit.discount.amount * quantity }), tax: __assign(__assign({}, price.total.tax), { amount: price.unit.tax.amount * quantity, portions: price.unit.tax.portions.map(function (portion, index) { return (__assign(__assign({}, portion), { amount: price.unit.tax.portions[index].amount * quantity })); }) }) }) })); };

var getAddress = function (address) {
    if (!address) {
        return undefined;
    }
    var apartment = address.apartment, city = address.city, countryCode = address.countryCode, firstName = address.firstName, lastName = address.lastName, streetName = address.streetName, streetNumber = address.streetNumber, additionalStreetInfo = address.additionalStreetInfo, postalCode = address.postalCode, region = address.region;
    return {
        city: city,
        countryCode: countryCode,
        firstName: firstName,
        lastName: lastName,
        streetName: streetName,
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : '',
        apartment: apartment !== null && apartment !== void 0 ? apartment : '',
        postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : '',
        additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : '',
        region: region !== null && region !== void 0 ? region : '',
    };
};

var getShippingMethod = function (shippingMethod) {
    return {
        id: shippingMethod.id,
        key: shippingMethod.key,
    };
};

var getCustomerDetails = function (details) {
    if (!details) {
        return undefined;
    }
    var email = details.email, phone = details.phone;
    return {
        email: email,
        phone: phone !== null && phone !== void 0 ? phone : '',
    };
};

var getAttribute = function (variant, attrName) {
    var attrValue = getAttrValue(variant, attrName);
    if (isNumber(attrValue) || isString(attrValue)) {
        return String(attrValue);
    }
    return '';
};

var numOrDefault = function (v, d) { return (typeof v === 'number' && !isNaN(v) ? v : d); };
var getCalculatedMaximumQuantity = function (maximumQuantity, availableQuantity) {
    var max = numOrDefault(maximumQuantity, Infinity);
    return Math.min(max, numOrDefault(availableQuantity, max));
};

var getCartPrices = function (prices) {
    var _a;
    return ({
        discountPrice: prices.discount.amount,
        paymentMethodPrice: (_a = prices.paymentMethodPrice) !== null && _a !== void 0 ? _a : undefined,
        subTotalPrice: prices.subtotal,
        shippingPrice: prices.shippingPrice,
        totalPrice: prices.gross,
    });
};

var contactLensOpticalParameters = new Set([
    'baseCurve',
    'diameter',
    'axis',
    'power',
    'cylinder',
    'addition',
]);
var getContactLensSpecs = function (attributes) {
    return attributes.filter(function (attribute) { return contactLensOpticalParameters.has(attribute.name); });
};
var TYPE_DETAILS_EYE_SIDE = {
    left: 'LEFT',
    right: 'RIGHT',
    both: 'BOTH',
};

var getLocalizedString = function (locale, localizedStrings) {
    var _a, _b;
    if (!localizedStrings) {
        return '';
    }
    var value = (_a = localizedStrings.find(function (string) { return string.locale === locale; })) === null || _a === void 0 ? void 0 : _a.value;
    // Business rule, localized version unavailable, try 'en' fallback
    if (value === undefined) {
        value = (_b = localizedStrings.find(function (string) { return string.locale.substr(0, 2) === 'en'; })) === null || _b === void 0 ? void 0 : _b.value;
    }
    return value || '';
};

var getDiscountDescriptions = function (appliedDiscounts, locale) {
    // Business rule: filter out discount that require a discount code
    var filteredDiscounts = appliedDiscounts.filter(function (discount) { return !discount.requiresDiscountCode; });
    return filteredDiscounts.map(function (discount) { return getLocalizedString(locale, discount.name); });
};

var getLineItemAvailability = function (availability) {
    if (!(availability === null || availability === void 0 ? void 0 : availability.channels)) {
        return undefined;
    }
    var channels = availability.channels.reduce(function (accumulator, currentValue) {
        var _a;
        return __assign(__assign({}, accumulator), (_a = {}, _a[currentValue.key] = {
            isOnStock: currentValue.value.isOnStock,
            availableQuantity: currentValue.value.availableQuantity,
        }, _a));
    }, {});
    return { channels: channels };
};

var getLineItemDiscount = function (discounts, price, locale) {
    var _a, _b;
    var productDiscount = discounts === null || discounts === void 0 ? void 0 : discounts.find(function (discount) { return discount.type === 'ProductDiscount'; });
    return {
        validFrom: (_a = productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.validFrom) !== null && _a !== void 0 ? _a : undefined,
        validUntil: (_b = productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.validUntil) !== null && _b !== void 0 ? _b : undefined,
        absoluteValue: (price === null || price === void 0 ? void 0 : price.total.discount.amount) || 0,
        relativeValue: price ? Number((price.total.discount.percentage * 100).toFixed(2)) : 0,
        description: getLocalizedString(locale, productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.description),
    };
};

var getLineItemImageUrl = function (variant, staticsUrl, isBynderImagesEnabled) {
    var _a, _b, _c, _d, _e;
    if (isBynderImagesEnabled) {
        var images = isValidImages((_a = variant.media) === null || _a === void 0 ? void 0 : _a.images) ? (_b = variant.media) === null || _b === void 0 ? void 0 : _b.images : undefined;
        var imageUrl = getFrontImage(images).url;
        return imageUrl + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    if ((_d = (_c = variant === null || variant === void 0 ? void 0 : variant.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url) {
        return "" + staticsUrl + ((_e = variant === null || variant === void 0 ? void 0 : variant.images) === null || _e === void 0 ? void 0 : _e[0].url) + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    return "" + staticsUrl;
};

var getLineItemName = function (product, intl) {
    if (product.productType === 'sunglasses') {
        return String(getAttrValue(product.masterData.current.variant, 'brand'));
    }
    return getLocalizedString(intl.locale, product.masterData.current.name);
};

var getLineItemPrice = function (priceObj) {
    var total = priceObj.total;
    var unit = priceObj.unit;
    return {
        total: {
            discount: total.discount.amount,
            original: total.subtotal,
            gross: total.gross,
            net: total.net,
            taxAmount: total.tax.amount,
        },
        unit: {
            discount: unit.discount.amount,
            original: unit.subtotal,
            gross: unit.gross,
            net: unit.net,
            taxAmount: unit.tax.amount,
        },
    };
};

var getLocalizedAttribute = function (variant, attrName, locale) {
    var _a;
    var attrValue = getAttrValue(variant, attrName);
    if (!isPlainObject(attrValue)) {
        return undefined;
    }
    /* Handle two different types of attribute values
      
      value: {
        key: 'aviator',
        label: {
          'en': 'Aviator',
      }
      
      },
      value: {
        en: 'Gold,Violet',
      },
    */
    var value = (_a = attrValue.label) !== null && _a !== void 0 ? _a : attrValue;
    return getLocalizedValue(value, locale);
};

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["QUARTERLY"] = "QUARTERLY";
})(BillingFrequency || (BillingFrequency = {}));
/**
 * Enum for bundle line items product types.
 */
var BundleLineItemProductType;
(function (BundleLineItemProductType) {
    BundleLineItemProductType["LENS"] = "LENS";
    BundleLineItemProductType["SOLUTION"] = "SOLUTION";
})(BundleLineItemProductType || (BundleLineItemProductType = {}));
/**
 * List of possible bundle line item types.
 */
var BundleLineItemType;
(function (BundleLineItemType) {
    BundleLineItemType["COMPOSITE"] = "COMPOSITE";
    BundleLineItemType["CONTACT_LENSES_BENELUX"] = "CONTACT_LENSES_BENELUX";
    BundleLineItemType["CONTACT_LENSES_SUBSCRIPTION"] = "CONTACT_LENSES_SUBSCRIPTION";
    BundleLineItemType["NON_PRESCRIPTION_BUNDLE"] = "NON_PRESCRIPTION_BUNDLE";
    BundleLineItemType["PRESCRIPTION_GLASSES"] = "PRESCRIPTION_GLASSES";
})(BundleLineItemType || (BundleLineItemType = {}));
/**
 * The type of the customer.
 */
var CartCustomerType;
(function (CartCustomerType) {
    CartCustomerType["B2B"] = "B2B";
    CartCustomerType["B2C"] = "B2C";
})(CartCustomerType || (CartCustomerType = {}));
/**
 * Channel where the cart was created/modified, one of ONLINE/STORE, default to ONLINE.
 */
var ChannelType;
(function (ChannelType) {
    ChannelType["ONLINE"] = "ONLINE";
    ChannelType["STORE"] = "STORE";
})(ChannelType || (ChannelType = {}));
var DeliveryFrequency;
(function (DeliveryFrequency) {
    DeliveryFrequency["MONTHLY"] = "MONTHLY";
    DeliveryFrequency["QUARTERLY"] = "QUARTERLY";
})(DeliveryFrequency || (DeliveryFrequency = {}));
/**
 * List of possible discount types.
 */
var DiscountType;
(function (DiscountType) {
    DiscountType["CartDiscount"] = "CartDiscount";
    DiscountType["ProductDiscount"] = "ProductDiscount";
})(DiscountType || (DiscountType = {}));
/**
 * Absolute or Relative
 */
var DiscountValueType;
(function (DiscountValueType) {
    DiscountValueType["ABSOLUTE"] = "ABSOLUTE";
    DiscountValueType["GIFT"] = "GIFT";
    DiscountValueType["RELATIVE"] = "RELATIVE";
})(DiscountValueType || (DiscountValueType = {}));
/**
 * List of possible eyeSide properties
 */
var EyeSide;
(function (EyeSide) {
    EyeSide["BOTH"] = "BOTH";
    EyeSide["LEFT"] = "LEFT";
    EyeSide["RIGHT"] = "RIGHT";
})(EyeSide || (EyeSide = {}));
var LineItemType;
(function (LineItemType) {
    LineItemType["BUNDLE"] = "BUNDLE";
    LineItemType["CONTACTLENSES"] = "CONTACTLENSES";
    LineItemType["REGULAR"] = "REGULAR";
})(LineItemType || (LineItemType = {}));
/**
 * List of possible validation codes for a validation error.
 */
var ValidationCode;
(function (ValidationCode) {
    ValidationCode["CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES"] = "CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES";
    ValidationCode["HAS_VALID_OPTICIAN_DETAILS"] = "HAS_VALID_OPTICIAN_DETAILS";
    ValidationCode["HAS_VALID_PRESCRIPTION_DATA_RANGES"] = "HAS_VALID_PRESCRIPTION_DATA_RANGES";
    ValidationCode["IS_IN_STOCK"] = "IS_IN_STOCK";
    ValidationCode["IS_VALID_AMOUNT_OF_MASTER_VARIANTS"] = "IS_VALID_AMOUNT_OF_MASTER_VARIANTS";
    ValidationCode["IS_VALID_CART_BY_PRESCRIPTION"] = "IS_VALID_CART_BY_PRESCRIPTION";
    ValidationCode["IS_VALID_EXPIRY_DATE"] = "IS_VALID_EXPIRY_DATE";
    ValidationCode["IS_VALID_QUANTITY"] = "IS_VALID_QUANTITY";
    ValidationCode["MAX_QUANTITY_PER_LINE_ITEM_TYPE"] = "MAX_QUANTITY_PER_LINE_ITEM_TYPE";
    ValidationCode["MAX_QUANTITY_PER_PRODUCT_TYPE"] = "MAX_QUANTITY_PER_PRODUCT_TYPE";
    ValidationCode["MAX_VARIANTS_PER_PRODUCT_TYPE"] = "MAX_VARIANTS_PER_PRODUCT_TYPE";
    ValidationCode["PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT"] = "PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT";
    ValidationCode["PRODUCTS_ARE_PUBLISHED"] = "PRODUCTS_ARE_PUBLISHED";
    ValidationCode["REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE"] = "REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE";
    ValidationCode["VALID_CART_BY_PRODUCT_TYPES"] = "VALID_CART_BY_PRODUCT_TYPES";
    ValidationCode["VALID_RELATIONS_BUNDLE_PRODUCTS"] = "VALID_RELATIONS_BUNDLE_PRODUCTS";
})(ValidationCode || (ValidationCode = {}));
/**
 * List of possible voucher types.
 */
var VoucherState;
(function (VoucherState) {
    VoucherState["ApplicationStoppedByPreviousDiscount"] = "ApplicationStoppedByPreviousDiscount";
    VoucherState["DoesNotMatchCart"] = "DoesNotMatchCart";
    VoucherState["MatchesCart"] = "MatchesCart";
    VoucherState["MaxApplicationReached"] = "MaxApplicationReached";
    VoucherState["NotActive"] = "NotActive";
    VoucherState["NotValid"] = "NotValid";
})(VoucherState || (VoucherState = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

var upperFirst = function (value) {
    return value[0].toUpperCase() + value.slice(1);
};
var mapToProductType = function (lineItemRaw) {
    switch (lineItemRaw.bundleLineItemsType) {
        case BundleLineItemType.CONTACT_LENSES_BENELUX:
        case BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION:
            return 'Contact-lenses';
        case BundleLineItemType.PRESCRIPTION_GLASSES:
            var mainLineItem = lineItemRaw.bundleLineItems.find(function (l) { return l.isMainBundleLineItem; });
            var productType = mainLineItem === null || mainLineItem === void 0 ? void 0 : mainLineItem.legacyProduct.productType;
            if (!productType) {
                return null;
            }
            var capitalized = upperFirst(productType);
            if (!CommerceToolsApi.isProductTypeName(capitalized)) {
                return null;
            }
            return capitalized;
    }
    return null;
};
var getProductUrl = function (formatProductUrl, lineItemRaw, slug, locale) {
    var _a, _b;
    if (!slug) {
        return undefined;
    }
    if (lineItemRaw.__typename === 'LineItemBundle') {
        var productType = mapToProductType(lineItemRaw);
        if (!productType) {
            return undefined;
        }
        return formatProductUrl({
            productType: productType,
            sku: lineItemRaw.sku,
            slug: (_a = {}, _a[locale] = slug, _a),
        });
    }
    return formatProductUrl({
        productType: upperFirst(lineItemRaw.legacyProduct.productType),
        sku: lineItemRaw.sku,
        slug: (_b = {}, _b[locale] = slug, _b),
    });
};

var getSubscriptionDetails = function (cart) {
    var cartContainsContactLensesSubscriptionLineItems = cart.lineItems
        .filter(function (item) {
        return item.lineItemType === LineItemType.BUNDLE;
    })
        .some(function (item) { return item.bundleLineItemsType === BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION; });
    if (!cartContainsContactLensesSubscriptionLineItems ||
        !cart.subscriptionPlan ||
        !cart.price.subscriptionPlanPrice) {
        return undefined;
    }
    var billingDate = new Date(cart.subscriptionPlan.billingDate);
    var subscriptionDetails = {
        billingDate: DateUtils.toLocalDate(billingDate),
        firstPayment: cart.price.subscriptionPlanPrice.invoicedAmount,
        recurringPayment: cart.price.subscriptionPlanPrice.total,
    };
    return subscriptionDetails;
};

var validationErrorLabelMap = {
    CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES: 'validations.containsMutuallyExclusiveProductTypes',
    IS_VALID_AMOUNT_OF_MASTER_VARIANTS: 'validations.maxMasterVariantQuantityExceeded',
    IS_VALID_CART_BY_PRESCRIPTION: 'validations.quantityExceededPrescriptionExpiryDate',
    IS_VALID_EXPIRY_DATE: 'validations.quantityExceededPrescriptionExpiryDate',
    IS_VALID_QUANTITY: 'validations.maxQuantitySkuExceeded',
    IS_IN_STOCK: 'validations.unavailableProductsInCart',
    MAX_VARIANTS_PER_PRODUCT_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    MAX_QUANTITY_PER_PRODUCT_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    MAX_QUANTITY_PER_LINE_ITEM_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    PRODUCTS_ARE_PUBLISHED: 'validations.unavailableProductsInCart',
    PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT: 'validations.unavailableProductsInCart',
    HAS_VALID_OPTICIAN_DETAILS: 'validations.prescriptionGlassesInvalidBundleCombination',
    HAS_VALID_PRESCRIPTION_DATA_RANGES: 'validations.prescriptionGlassesInvalidBundleCombination',
    REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE: 'validations.prescriptionGlassesInvalidBundleCombination',
    VALID_CART_BY_PRODUCT_TYPES: 'validations.prescriptionGlassesInvalidBundleCombination',
    VALID_RELATIONS_BUNDLE_PRODUCTS: 'validations.prescriptionGlassesInvalidBundleCombination',
};
var getValidationErrorCodes = function (validationInput) {
    if (!validationInput) {
        return [];
    }
    var lineItemValidationErrors = validationInput.cartLineItemErrors;
    if (lineItemValidationErrors) {
        return getLineItemValidationErrorCodes(lineItemValidationErrors);
    }
    return [];
};
var getLineItemValidationErrorCodes = function (lineItemValidationErrors) {
    var codes = lineItemValidationErrors.reduce(function (accumulator, currentValue) {
        var validationCode = currentValue.errors.map(function (error) { return error.validationCode; });
        return __spreadArray(__spreadArray([], __read(accumulator)), __read(validationCode));
    }, []);
    var uniqueValidationCodes = __spreadArray([], __read(new Set(codes)));
    return uniqueValidationCodes.map(function (code) { return validationErrorLabelMap[code]; });
};

var isContactLensesSubscriptionLineItem = function (lineItem) { return lineItem.type === 'contact-lenses-subscription'; };

var getAllowBackOrder = function (variant) {
    var allowBackOrder = getAttrValue(variant, 'allowBackOrder');
    return isBoolean(allowBackOrder) ? allowBackOrder : undefined;
};

var getSharedProps = function (lineItemRaw, product, intl) {
    var variant = product.masterData.current.variant;
    return {
        allowBackOrder: getAllowBackOrder(variant),
        availability: getLineItemAvailability(variant.availability),
        currency: intl.currency,
        discount: getLineItemDiscount(lineItemRaw.discounts, lineItemRaw.price, intl.locale),
        id: lineItemRaw.id,
        isGift: lineItemRaw.isGift,
        name: getLineItemName(product, intl),
        price: getLineItemPrice(lineItemRaw.price),
        productType: product.productType,
        quantity: lineItemRaw.quantity,
    };
};

var getContactLensSpecifications = function (specs) {
    var _a, _b, _c, _d, _e;
    return [
        { name: 'baseCurve', value: (_a = specs === null || specs === void 0 ? void 0 : specs.baseCurve) === null || _a === void 0 ? void 0 : _a.toString() },
        { name: 'diameter', value: (_b = specs === null || specs === void 0 ? void 0 : specs.diameter) === null || _b === void 0 ? void 0 : _b.toString() },
        { name: 'axis', value: (_c = specs === null || specs === void 0 ? void 0 : specs.axis) === null || _c === void 0 ? void 0 : _c.toString() },
        { name: 'power', value: (_d = specs === null || specs === void 0 ? void 0 : specs.power) === null || _d === void 0 ? void 0 : _d.toString() },
        { name: 'cylinder', value: (_e = specs === null || specs === void 0 ? void 0 : specs.cylinder) === null || _e === void 0 ? void 0 : _e.toString() },
    ].filter(function (spec) { return Boolean(spec.value); });
};

var getLegacyProductByType = function (lineItems, type) {
    var _a, _b;
    if (!type) {
        return (_a = lineItems.find(function (lineItem) { return lineItem.isMainBundleLineItem; })) === null || _a === void 0 ? void 0 : _a.legacyProduct;
    }
    return (_b = lineItems.find(function (lineItem) { return lineItem.type === type; })) === null || _b === void 0 ? void 0 : _b.legacyProduct;
};

var getSolutionProperties = function (solutionProduct, intl, settings) {
    return {
        solutionSku: solutionProduct.sku,
        solutionName: getLineItemName(solutionProduct, intl),
        solutionImageUrl: getLineItemImageUrl(solutionProduct.masterData.current.variant, settings.staticsUrl, settings.isBynderImagesEnabled),
    };
};

var mapContactLensesBundleBeneluxLineItem$1 = function (lineItemRaw, settings, intl) {
    var contactLensesProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, BundleLineItemProductType.LENS);
    var solutionsProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, BundleLineItemProductType.SOLUTION);
    var mainBundleProduct = getLegacyProductByType(lineItemRaw.bundleLineItems);
    if (!contactLensesProduct || !mainBundleProduct) {
        console.error('This bundle does not contain Contact Lenses or a mainBundleProduct');
        return null;
    }
    var contactLensVariant = contactLensesProduct.masterData.current.variant;
    var mainProductVariant = mainBundleProduct.masterData.current.variant;
    var shared = getSharedProps(lineItemRaw, mainBundleProduct, intl);
    var slug = getAttribute(mainProductVariant, 'parentSlug');
    var typeDetails = lineItemRaw.typeDetails;
    var _a = typeDetails.prescription, leftLens = _a.leftLens, rightLens = _a.rightLens;
    var solutionProperties = solutionsProduct
        ? getSolutionProperties(solutionsProduct, intl, settings)
        : null;
    return __assign(__assign(__assign({}, shared), { type: 'contact-lenses-bundle-benelux', sku: lineItemRaw.sku, imageSku: getAttribute(mainProductVariant, 'imageSku'), productSlug: slug, productId: contactLensesProduct.id, productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale), brand: {
            name: getAttribute(contactLensVariant, 'brand'),
            model: getAttribute(contactLensVariant, 'brandModel'),
            modelCode: getAttribute(contactLensVariant, 'brandModelCode'),
        }, imageUrl: settings.isBynderImagesEnabled
            ? getLineItemImageUrl(mainProductVariant, settings.staticsUrl, true)
            : getLineItemImageUrl(contactLensVariant, settings.staticsUrl), lensType: getLocalizedAttribute(mainProductVariant, 'lensType', intl.locale) || '', leftEyeProduct: {
            name: getLineItemName(contactLensesProduct, intl),
            specs: getContactLensSpecifications(leftLens),
        }, rightEyeProduct: {
            name: getLineItemName(contactLensesProduct, intl),
            specs: getContactLensSpecifications(rightLens),
        } }), solutionProperties);
};

var billingFrequencyLabelMap = {
    MONTHLY: 'cart.subscription.billingFrequency.monthly',
    QUARTERLY: 'cart.subscription.billingFrequency.quarterly',
};
var deliveryFrequencyLabelMap = {
    MONTHLY: 'cart.subscription.deliveryFrequency.monthly',
    QUARTERLY: 'cart.subscription.deliveryFrequency.quarterly',
};
var getSubscriptionFrequencyLabel = function (enumValue, type) {
    switch (type) {
        case 'billingFrequency':
            return billingFrequencyLabelMap[enumValue];
        case 'deliveryFrequency':
            return deliveryFrequencyLabelMap[enumValue];
    }
};

var SubscriptionType;
(function (SubscriptionType) {
    /**
     * Monthly payment, monthly delivery
     */
    SubscriptionType["MONTHLY"] = "MONTHLY";
    /**
     * Quarterly payment, quarterly delivery
     */
    SubscriptionType["QUARTERLY"] = "QUARTERLY";
    /**
     * Monthly payment, quarterly delivery
     * This type has a first payment of three months
     */
    SubscriptionType["MIXED_MONTHLY"] = "MIXED_MONTHLY";
    /**
     * Quarterly payment, monthly delivery.
     */
    SubscriptionType["MIXED_QUARTERLY"] = "MIXED_QUARTERLY";
})(SubscriptionType || (SubscriptionType = {}));

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get SubscriptionType () { return SubscriptionType; }
});

var getSubscriptionType$1 = function (typeDetails) {
    if (typeDetails.billingFrequency.valueOf() === typeDetails.deliveryFrequency.valueOf()) {
        if (typeDetails.billingFrequency === BillingFrequency.MONTHLY) {
            return SubscriptionType.MONTHLY;
        }
        return SubscriptionType.QUARTERLY;
    }
    if (typeDetails.billingFrequency === BillingFrequency.MONTHLY) {
        return SubscriptionType.MIXED_MONTHLY;
    }
    return SubscriptionType.MIXED_QUARTERLY;
};

var mapContactLensesSubscription = function (lineItemRaw, settings, intl) {
    var solutionsProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, BundleLineItemProductType.SOLUTION);
    var mainBundleProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, BundleLineItemProductType.LENS);
    if (!mainBundleProduct) {
        console.error('This ContactLensesSubscriptionLineItem does not have a mainBundleLineItem');
        return null;
    }
    var mainBundleProductVariant = mainBundleProduct.masterData.current.variant;
    var shared = getSharedProps(lineItemRaw, mainBundleProduct, intl);
    var slug = getLocalizedString(intl.locale, mainBundleProduct.masterData.current.slug);
    var typeDetails = lineItemRaw.typeDetails;
    var _a = typeDetails.prescriptionForSubscription, leftLens = _a.leftLens, rightLens = _a.rightLens;
    var solutionProperties = solutionsProduct
        ? getSolutionProperties(solutionsProduct, intl, settings)
        : null;
    var billingFrequency = getSubscriptionFrequencyLabel(typeDetails.billingFrequency, 'billingFrequency');
    var deliveryFrequency = getSubscriptionFrequencyLabel(typeDetails.deliveryFrequency, 'deliveryFrequency');
    var mapLensProductDetails = function (lensProduct) {
        if (lensProduct === null) {
            return undefined;
        }
        return {
            name: getLineItemName(mainBundleProduct, intl),
            specs: getContactLensSpecifications(lensProduct),
        };
    };
    return __assign(__assign(__assign({}, shared), { type: 'contact-lenses-subscription', sku: lineItemRaw.sku, imageSku: getAttribute(mainBundleProductVariant, 'imageSku'), productSlug: slug, productId: mainBundleProduct.id, productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale), brand: {
            name: getAttribute(mainBundleProductVariant, 'brand'),
            model: getAttribute(mainBundleProductVariant, 'brandModel'),
            modelCode: getAttribute(mainBundleProductVariant, 'brandModelCode'),
        }, imageUrl: getLineItemImageUrl(mainBundleProductVariant, settings.staticsUrl, settings.isBynderImagesEnabled), lensType: getLocalizedAttribute(mainBundleProductVariant, 'lensType', intl.locale) || '', leftEyeProduct: mapLensProductDetails(leftLens), rightEyeProduct: mapLensProductDetails(rightLens), billingFrequency: intl.getLabel(billingFrequency), deliveryFrequency: intl.getLabel(deliveryFrequency), packageQuantity: getAttribute(mainBundleProductVariant, 'packageQuantity'), subscriptionType: getSubscriptionType$1(typeDetails) }), solutionProperties);
};

/**
 * We're doing a localeCompore to catch some casing differences we've encountered
 * in the past when receiving product data from the backend.
 */
function findBundledLineItem(lineItems, productType) {
    return lineItems.find(function (lineItem) {
        return lineItem.legacyProduct.productType.localeCompare(productType, 'en', {
            sensitivity: 'base',
            usage: 'search',
        }) === 0;
    });
}

function getBundledLineItemProductVariant(bundleLineItem) {
    return bundleLineItem.legacyProduct.masterData.current.variant;
}

function getBundledProductInfo(bundleLineItem, intl) {
    var name = bundleLineItem.legacyProduct.masterData.current.name;
    var variant = getBundledLineItemProductVariant(bundleLineItem);
    var variationAttribute = getAttribute(variant, 'variationAttribute');
    var variationAttributeValue = getLocalizedAttrValue(variant, variationAttribute, intl.locale);
    var bundleTitle = getLocalizedString(intl.locale, name);
    return __assign({ sku: variant.sku, title: !!variationAttributeValue ? bundleTitle + " - " + variationAttributeValue : bundleTitle }, (bundleLineItem.price
        ? {
            price: getLineItemPrice(bundleLineItem.price).unit,
            discount: getLineItemDiscount(bundleLineItem.discounts, bundleLineItem.price, intl.locale),
        }
        : {}));
}

function getBundledFrameInfo(lineItemRaw, bundleLineItem, settings, intl) {
    var variant = getBundledLineItemProductVariant(bundleLineItem);
    var brandName = getAttribute(variant, 'brand');
    var model = getAttribute(variant, 'brandModel');
    var modelCode = getAttribute(variant, 'brandModelCode');
    var modelColorCode = getAttribute(variant, 'brandModelColorCode');
    var title = __spreadArray([], __read(new Set([brandName, model, modelCode, modelColorCode].filter(Boolean)))).join(' ');
    return __assign(__assign({}, getBundledProductInfo(bundleLineItem, intl)), { title: title, productId: lineItemRaw.id, brand: {
            name: brandName,
            model: model,
            modelCode: modelCode,
        } });
}

/**
 * getLensDetails
 *
 * Removes all null values and __typename from the lens object
 */
var getLensDetails = function (lens) {
    return Object.entries(lens).reduce(function (acc, _a) {
        var _b = __read(_a, 2), name = _b[0], value = _b[1];
        if (value !== null && name !== '__typename') {
            acc[name] = value;
        }
        return acc;
    }, {});
};

function getPrescription(typeDetails) {
    if (typeDetails.isExistingCustomer) {
        return {
            type: 'ExistingCustomer',
        };
    }
    if (typeDetails.newPrescription) {
        return {
            type: 'NewPrescription',
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens),
        };
    }
    if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: 'PrescriptionFile',
            uploadedPrescriptionFile: {
                fileName: typeDetails.prescriptionFile.fileName,
            },
            uploadedPupillaryDistanceFile: {
                fileName: typeDetails.pupillaryDistanceFile.fileName,
            },
        };
    }
    return {
        type: 'EmailPrescription',
    };
}

function getLineItemCartDiscountDescription(lineItemRaw, locale) {
    var discounts = lineItemRaw.discounts;
    if (!discounts || discounts.length === 0) {
        return;
    }
    var cartDiscounts = discounts === null || discounts === void 0 ? void 0 : discounts.filter(function (discount) { return discount.type === 'CartDiscount'; });
    if (!cartDiscounts.length) {
        return;
    }
    return getLocalizedString(locale, cartDiscounts[0].description);
}

var mapPrescriptionGlassesLineItem$1 = function (lineItemRaw, settings, intl) {
    var _a, _b, _c, _d;
    var mainBundleLineItem = lineItemRaw.bundleLineItems.find(function (bundleLineItem) { return bundleLineItem.isMainBundleLineItem; });
    if (!mainBundleLineItem) {
        console.error("None of the bundleLineItems have isMainBundleLineItem in LineItemBundle with id " + lineItemRaw.id);
        return null;
    }
    var lensTypeBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'LensTypes');
    var lensPackageBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'PrescriptionGlassPackages');
    if (!lensTypeBundleLineItem || !lensPackageBundleLineItem) {
        console.error("Either lensTypeBundleLineItem or lensPackageBundleLineItem are missing from LineItemBundle with id " + lineItemRaw.id);
        return null;
    }
    var prescriptionTypeDetails = lineItemRaw.typeDetails;
    var addOnBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'PrescriptionGlassPackageOptions');
    var shared = getSharedProps(lineItemRaw, mainBundleLineItem.legacyProduct, intl);
    // Assumes the frame is the main bundled line item
    var frame = getBundledFrameInfo(lineItemRaw, mainBundleLineItem, settings, intl);
    var lensType = getBundledProductInfo(lensTypeBundleLineItem, intl);
    var lensPackage = getBundledProductInfo(lensPackageBundleLineItem, intl);
    var addOn = !!addOnBundleLineItem ? getBundledProductInfo(addOnBundleLineItem, intl) : undefined;
    // Product discounts
    var frameDiscount = ((_a = frame.price) === null || _a === void 0 ? void 0 : _a.discount) || 0;
    var lensTypeDiscount = ((_b = lensType.price) === null || _b === void 0 ? void 0 : _b.discount) || 0;
    var lensPackageDiscount = ((_c = lensPackage.price) === null || _c === void 0 ? void 0 : _c.discount) || 0;
    var addOnDiscount = ((_d = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _d === void 0 ? void 0 : _d.discount) || 0;
    var totalProductDiscount = shared.quantity * (frameDiscount + lensTypeDiscount + lensPackageDiscount + addOnDiscount);
    // Total discount (cart discount + (all product discounts * quantity))
    var totalDiscount = shared.price.total.discount;
    var slug = getLocalizedString(intl.locale, mainBundleLineItem.legacyProduct.masterData.current.slug);
    var variant = getBundledLineItemProductVariant(mainBundleLineItem);
    return __assign(__assign(__assign({}, shared), { type: 'prescription-glasses', name: frame.title, frame: frame, imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled), lensType: lensType, lensPackage: lensPackage, addOn: addOn, productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale), prescription: getPrescription(prescriptionTypeDetails) }), (!!totalDiscount
        ? {
            cartDiscount: {
                amount: totalDiscount - totalProductDiscount,
                description: getLineItemCartDiscountDescription(lineItemRaw, intl.locale),
            },
        }
        : {}));
};

var mapBundleProduct = function (lineItemRaw, settings, intl) {
    switch (lineItemRaw.bundleLineItemsType) {
        case BundleLineItemType.CONTACT_LENSES_BENELUX:
            return mapContactLensesBundleBeneluxLineItem$1(lineItemRaw, settings, intl);
        case BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION:
            return mapContactLensesSubscription(lineItemRaw, settings, intl);
        case BundleLineItemType.PRESCRIPTION_GLASSES:
            return mapPrescriptionGlassesLineItem$1(lineItemRaw, settings, intl);
        default:
            console.error("Encountered unsupported bundle line item type \"" + lineItemRaw.bundleLineItemsType + "\" with SKU: " + lineItemRaw.sku);
            return null;
    }
};

var getEyeSide = function (typeDetails) {
    if (typeDetails && 'eyeSide' in typeDetails && typeDetails.eyeSide) {
        return typeDetails.eyeSide.toLowerCase();
    }
    return;
};

var getLocalizedAttributes = function (variant, attrName, locale) {
    var attrValues = getAttrValue(variant, attrName);
    if (isPlainObject(attrValues)) {
        return [getLocalizedValue(attrValues, locale)];
    }
    if (isArray(attrValues)) {
        return attrValues.map(function (attrValue) {
            return getLocalizedValue(attrValue, locale);
        });
    }
    return [];
};

var mapRegularProduct = function (lineItemRaw, settings, intl) {
    var product = lineItemRaw.legacyProduct;
    var variant = product.masterData.current.variant;
    var shared = getSharedProps(lineItemRaw, product, intl);
    var slug = getLocalizedString(intl.locale, product.masterData.current.slug);
    var productAttributes = {
        sku: lineItemRaw.sku,
        productSlug: slug,
        productId: product.id,
        productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale),
        brand: {
            name: getAttribute(variant, 'brand'),
            model: getAttribute(variant, 'brandModel'),
            modelCode: getAttribute(variant, 'brandModelCode'),
        },
    };
    switch (product.productType) {
        case 'solutions':
            return __assign(__assign(__assign({ type: 'solutions' }, shared), productAttributes), { imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled), solutionType: getAttribute(variant, 'solutionType'), solutionVolume: getAttribute(variant, 'volume') });
        case 'contact-lenses':
            return __assign(__assign(__assign({ type: 'contact-lenses' }, shared), productAttributes), { colorLens: getAttribute(variant, 'color'), eyeSide: getEyeSide(lineItemRaw.typeDetails), imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled), lensType: getLocalizedAttribute(variant, 'lensType', intl.locale) || '', packageQuantity: getAttribute(variant, 'packageQuantity'), replacementFrequency: getLocalizedAttribute(variant, 'replacementFrequency', intl.locale), sapArticleNumber: getAttribute(variant, 'sapArticleNumber'), specs: getContactLensSpecs(variant.attributes) });
        case 'sunglasses':
            return __assign(__assign(__assign({ type: 'sunglasses' }, shared), productAttributes), { frame: {
                    frameShape: getLocalizedAttribute(variant, 'frameShape', intl.locale),
                    frameMaterial: getLocalizedAttributes(variant, 'frameMaterial', intl.locale),
                    frameColor: getLocalizedAttributes(variant, 'frameColor', intl.locale),
                }, gender: getLocalizedAttributes(variant, 'gender', intl.locale), imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled) });
        default:
            console.log("Encountered unsupported productType '" + product.productType + "' with sku '" + variant.sku + "'");
            return null;
    }
};
var lineItemDataMapper = function (lineItemsRaw, settings, intl) {
    var lineItems = lineItemsRaw.map(function (lineItemRaw) {
        switch (lineItemRaw.__typename) {
            case 'LineItemBundle':
                return mapBundleProduct(lineItemRaw, settings, intl);
            case 'LineItemContactLenses':
            case 'LineItemRegular':
                return mapRegularProduct(lineItemRaw, settings, intl);
        }
    });
    return lineItems.filter(function (lineItem) { return Boolean(lineItem); });
};

var CART_STORAGE_KEY = 'stored_cart';
var initialState = {
    cartId: null,
    cartHash: null,
    cartCount: 0,
};
var useCartStorage = function () {
    var _a = __read(useLocalStorage(CART_STORAGE_KEY, initialState), 2), data = _a[0], setData = _a[1];
    React.useDebugValue(data);
    var setCartId = React.useCallback(function (cartId) {
        setData(function (state) { return (__assign(__assign({}, state), { cartId: cartId })); });
    }, [setData]);
    var setCartHash = React.useCallback(function (cartHash) {
        setData(function (state) { return (__assign(__assign({}, state), { cartHash: cartHash })); });
    }, [setData]);
    var setCartCount = React.useCallback(function (newCount) {
        if (cartCountVar() !== newCount) {
            cartCountVar(newCount);
        }
        return setData(function (state) {
            if (state.cartCount === newCount) {
                return state;
            }
            return __assign(__assign({}, state), { cartCount: newCount });
        });
    }, [setData]);
    var reset = function () {
        setData(initialState);
    };
    return [data, { setCartId: setCartId, setCartHash: setCartHash, setCartCount: setCartCount, reset: reset }];
};

var useGetCart = function () {
    var settings = useCartSettings();
    var _a = __read(useCartStorage(), 2), cart = _a[0], _b = _a[1], setCartId = _b.setCartId, setCartHash = _b.setCartHash, setCartCount = _b.setCartCount, reset = _b.reset;
    var cartIdRef = React.useRef(cart.cartId);
    var cartId = settings.cartId, cartHash = settings.cartHash;
    // This is needed to prefill the cart with the customer logic in the back-office flow.
    if (cartId && cartHash && (cart.cartId !== cartId || cart.cartHash !== cartHash)) {
        setCartId(cartId);
        setCartHash(cartHash);
        cartIdRef.current = cartId;
    }
    var onValidationError = function (validationCodes) {
        validationCodes.forEach(function (code) { return toast.failed("cart." + code); });
    };
    var _c = __read(useLazyQuery(GET_CART, {
        onCompleted: function (data) {
            if (!data.getCart.validationErrors) {
                setCartCount(data.getCart.cart.numberOfItems);
            }
            else {
                var validationErrorCodes = getValidationErrorCodes(data.getCart.validationErrors);
                onValidationError && onValidationError(validationErrorCodes);
                reset();
            }
        },
        onError: function () {
            reset();
        },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        context: { forwardHeaders: { 'cart-hash': cart.cartHash } },
    }), 2), getCart = _c[0], _d = _c[1], called = _d.called, loading = _d.loading, data = _d.data, error = _d.error, refetch = _d.refetch;
    var refetchCallback = React.useCallback(function () {
        if (cartIdRef.current) {
            // Refetch is undefined if the initial run has not been executed
            refetch
                ? refetch({ id: cartIdRef.current })
                : getCart({ variables: { id: cartIdRef.current } });
        }
    }, [getCart, refetch]);
    React.useEffect(function () {
        if (cartIdRef.current) {
            getCart({ variables: { id: cartIdRef.current } });
        }
    }, [getCart]);
    return {
        called: called,
        loading: loading,
        data: !!cart.cartId ? data : null,
        error: error,
        refetch: refetchCallback,
    };
};

var CartProvider = function (_a) {
    var children = _a.children;
    var _b = useGetCart(), called = _b.called, refetch = _b.refetch, loading = _b.loading, data = _b.data, error = _b.error;
    var settings = useCartSettings();
    var intl = useIntl();
    var cart = React.useMemo(function () {
        if (data === null) {
            return null;
        }
        if (!data) {
            return undefined;
        }
        var lineItemsRaw = data.getCart.cart.lineItems;
        return {
            id: data.getCart.cart.id,
            numberOfItems: data.getCart.cart.numberOfItems,
            lineItems: lineItemDataMapper(lineItemsRaw, settings, intl),
            prices: getCartPrices(data.getCart.cart.price),
            discountDescriptions: getDiscountDescriptions(data.getCart.cart.appliedDiscounts, intl.locale),
            voucherCodes: getActiveVoucherCodes(data.getCart.cart.vouchers),
            subscription: getSubscriptionDetails(data.getCart.cart),
            isAccountRequired: !!data.getCart.cart.isAccountRequired,
            billingAddress: getAddress(data.getCart.cart.billingAddress),
            shippingAddress: getAddress(data.getCart.cart.shippingAddress),
            shippingMethod: getShippingMethod(data.getCart.cart.shippingMethod),
            customerDetails: getCustomerDetails(data.getCart.cart.customerDetails),
        };
    }, [data, intl, settings]);
    var value = React.useMemo(function () { return ({ cart: cart, refetch: refetch, loading: loading, error: error, called: called }); }, [
        cart,
        refetch,
        called,
        loading,
        error,
    ]);
    if (typeof children === 'function') {
        return React.createElement(CartContext.Provider, { value: value }, children(value));
    }
    return React.createElement(CartContext.Provider, { value: value }, children);
};

var QuotationContext = React.createContext(null);
QuotationContext.displayName = 'QuotationContext';
var useQuotation = function () {
    var isDownloadQuotationEnabled = useFeatureToggles().isDownloadQuotationEnabled;
    var context = React.useContext(QuotationContext);
    if (!isDownloadQuotationEnabled) {
        return {};
    }
    if (!context) {
        throw new Error('No QuotationContext available. You might still need to wrap your component with the QuotationProvider.');
    }
    return context;
};

var QuotationProvider = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return React.createElement(QuotationContext.Provider, { children: children, value: rest });
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useCart: useCart,
  CartProvider: CartProvider,
  useCartSettings: useCartSettings,
  CartSettingsProvider: CartSettingsProvider,
  useQuotation: useQuotation,
  QuotationProvider: QuotationProvider
});

var convertAttributeToLowerCase = function (attribute) {
    if (!attribute) {
        return '';
    }
    return Array.isArray(attribute) ? attribute.join().toLowerCase() : attribute.toLowerCase();
};
var calcPrice = function (centAmount) {
    var price = !isNaN(centAmount) ? (centAmount / 100).toFixed(2).toString() : '0.00';
    if (price === '0') {
        return '0.00';
    }
    return price;
};
var createPriceSpecification = function (lineItem) {
    var unit = lineItem.price.unit;
    return {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: String(calcPrice(unit.gross)),
        priceCurrency: lineItem.currency,
        validFrom: lineItem.discount.validFrom,
        validThrough: lineItem.discount.validUntil,
        valueAddedTaxIncluded: true,
        priceComponent: [
            {
                '@type': 'UnitPriceSpecification',
                name: 'Price excluding VAT',
                price: String(calcPrice(unit.net)),
                valueAddedTaxIncluded: false,
            },
            {
                '@type': 'UnitPriceSpecification',
                name: 'VAT',
                price: String(calcPrice(unit.taxAmount)),
                valueAddedTaxIncluded: true,
            },
        ],
    };
};
var createOfferObject = function (lineItem) {
    return {
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: lineItem.quantity || 1,
        },
        priceSpecification: createPriceSpecification(lineItem),
    };
};
var createProductObject = function (lineItem) {
    var url = (window.location && window.location.origin) || '';
    if (lineItem.productUrl) {
        url += lineItem.productUrl;
    }
    if (lineItem.type === 'prescription-glasses') {
        var frame_1 = lineItem.frame, name_1 = lineItem.name;
        var brand_1 = frame_1.brand, productId_1 = frame_1.productId, sku_1 = frame_1.sku;
        return {
            '@type': 'Product',
            '@id': url + "#product",
            category: 'Optical',
            url: url,
            brand: brand_1.name,
            name: name_1,
            sku: sku_1,
            gtin13: sku_1,
            productID: productId_1,
            offers: [createOfferObject(lineItem)],
        };
    }
    var name = lineItem.name, sku = lineItem.sku, productId = lineItem.productId, type = lineItem.type, brand = lineItem.brand;
    var frame = lineItem.type === 'sunglasses' ? lineItem.frame : null;
    return {
        '@type': 'Product',
        '@id': url + "#product",
        url: url,
        model: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameShape),
        name: name,
        productID: productId,
        gtin13: sku,
        category: type,
        brand: brand.name,
        material: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameMaterial),
        color: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameColor),
        offers: [createOfferObject(lineItem)],
    };
};

var getSubscriptionType = function (lineItem) {
    return lineItem.type === 'contact-lenses-bundle-benelux'
        ? DataLayer.DataLayerTypes.PurchaseType.Subscription
        : DataLayer.DataLayerTypes.PurchaseType.OneTime;
};
var getSharedAttributes = function (lineItem, lineItemType, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var brand = lineItem.brand, sku = lineItem.sku, price = lineItem.price;
    var modelCode = brand.modelCode && brand.modelCode !== brand.model ? "" + brand.modelCode : null;
    return {
        name: brand.model + " " + modelCode || '',
        id: sku,
        price: calcPrice$1(price.unit.gross),
        dimension143: getSubscriptionType(lineItem),
        dimension144: lineItemType,
        dimension145: 'true',
        metric140: calcPrice$1(price.unit.original),
        metric141: calcPrice$1(price.unit.discount),
        metric142: calcPrice$1(price.unit.taxAmount),
        quantity: quantity,
    };
};
var getSunglassesAttributes = function (lineItem, quantity) {
    var _a, _b, _c;
    var brand = lineItem.brand, frame = lineItem.frame, gender = lineItem.gender, sku = lineItem.sku;
    var genderValue = gender && gender.map(function (value) { return value.toLowerCase(); }).join();
    return __assign(__assign({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity)), { category: DataLayer.DataLayerTypes.Category.Sunglasses, brand: brand.name || '', variant: ((_a = frame === null || frame === void 0 ? void 0 : frame.frameShape) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '', dimension16: genderValue || '', dimension140: sku, dimension146: ((_b = frame === null || frame === void 0 ? void 0 : frame.frameMaterial) === null || _b === void 0 ? void 0 : _b.join().toLowerCase()) || '', dimension147: ((_c = frame === null || frame === void 0 ? void 0 : frame.frameColor) === null || _c === void 0 ? void 0 : _c.join().toLowerCase()) || '' });
};
var getContactLensesAttributes = function (lineItem, quantity) {
    var _a;
    return (__assign(__assign({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity)), { category: DataLayer.DataLayerTypes.Category.ContactLenses, variant: lineItem.lensType || '', dimension140: lineItem.sku, dimension148: ((_a = lineItem.replacementFrequency) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '' }));
};
var getSolutionsAttributes = function (lineItem, quantity) { return (__assign(__assign({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Single, quantity)), { category: DataLayer.DataLayerTypes.Category.Solutions, brand: lineItem.brand.name || '', variant: lineItem.solutionVolume + 'ml', dimension140: lineItem.sku, dimension146: lineItem.solutionType })); };
var getContactLensesBundleBeneluxAttributes = function (lineItem, quantity) { return (__assign(__assign({}, getSharedAttributes(lineItem, DataLayer.DataLayerTypes.LineItemType.Bundle, quantity)), { category: DataLayer.DataLayerTypes.Category.ContactLenses, variant: lineItem.lensType })); };
var getPrescriptionGlassesAttributes = function (lineItem, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var frame = lineItem.frame, name = lineItem.name, price = lineItem.price, productType = lineItem.productType;
    var category = productType === 'sunglasses'
        ? DataLayer.DataLayerTypes.Category.Sunglasses
        : DataLayer.DataLayerTypes.Category.Optical;
    return {
        category: category,
        name: name,
        brand: frame.brand.name || '',
        id: frame.sku,
        price: calcPrice$1(price.unit.gross),
        dimension140: frame.sku,
        dimension143: getSubscriptionType(lineItem),
        dimension144: DataLayer.DataLayerTypes.LineItemType.Bundle,
        dimension145: 'true',
        metric140: calcPrice$1(price.unit.original),
        metric141: calcPrice$1(price.unit.discount),
        metric142: calcPrice$1(price.unit.taxAmount),
        quantity: quantity,
    };
};
var mapClientModelToProductObject = function (lineItem, quantity) {
    switch (lineItem.type) {
        case 'sunglasses':
            return getSunglassesAttributes(lineItem, quantity);
        case 'contact-lenses':
            return getContactLensesAttributes(lineItem, quantity);
        case 'solutions':
            return getSolutionsAttributes(lineItem, quantity);
        case 'contact-lenses-bundle-benelux':
            return getContactLensesBundleBeneluxAttributes(lineItem, quantity);
        case 'prescription-glasses':
            return getPrescriptionGlassesAttributes(lineItem, quantity);
    }
};

var mapLineItemToDataLayerEvent = function (eventType, lineItems, cartId) {
    var currency = lineItems[0].currency;
    switch (eventType) {
        case 'add':
            return {
                event: 'gvAddToCart',
                atfEcommerce: {
                    ecommerce: {
                        currencyCode: currency,
                        cart: { id: cartId },
                        add: {
                            products: lineItems.map(function (lineItem) {
                                return mapClientModelToProductObject(lineItem, lineItem.quantity);
                            }),
                        },
                    },
                },
            };
        case 'remove':
            return {
                event: 'gvRemoveFromCart',
                atfEcommerce: {
                    ecommerce: {
                        currencyCode: currency,
                        cart: { id: cartId },
                        remove: {
                            products: lineItems.map(function (lineItem) {
                                return mapClientModelToProductObject(lineItem, lineItem.quantity);
                            }),
                        },
                    },
                },
            };
    }
};

var errorsMapping = {
    CART_IS_EMPTY: 'errors.cartIsEmpty',
    MISSING_CART_ID: 'errors.missingCartID',
    SOMETHING_WENT_WRONG: 'errors.somethingWentWrong',
    CART_NOT_FOUND: 'errors.cartNotFound',
};

var mapContactLensesLineItem = function (_a) {
    var sku = _a.sku, quantity = _a.quantity, typeDetails = _a.typeDetails;
    var eyeSide = typeDetails.eyeSide, prescriptionExpiryDate = typeDetails.prescriptionExpiryDate, prescriptionExamDate = typeDetails.prescriptionExamDate, internalOptician = typeDetails.internalOptician, externalOptician = typeDetails.externalOptician;
    return {
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.CONTACTLENSES,
        typeDetails: {
            eyeSide: eyeSide === 'left' ? EyeSide.LEFT : EyeSide.RIGHT,
            prescriptionExpiryDate: prescriptionExpiryDate,
            prescriptionExamDate: prescriptionExamDate,
            internalOptician: internalOptician,
            externalOptician: externalOptician,
        },
    };
};

var mapContactLensesBundleBeneluxLineItem = function (_a) {
    var sku = _a.sku, quantity = _a.quantity, typeDetails = _a.typeDetails;
    var leftLensBaseCurve = typeDetails.leftLensBaseCurve, leftLensDiameter = typeDetails.leftLensDiameter, leftLensPower = typeDetails.leftLensPower, leftLensAxis = typeDetails.leftLensAxis, leftLensCylinder = typeDetails.leftLensCylinder;
    var rightLensBaseCurve = typeDetails.rightLensBaseCurve, rightLensDiameter = typeDetails.rightLensDiameter, rightLensPower = typeDetails.rightLensPower, rightLensAxis = typeDetails.rightLensAxis, rightLensCylinder = typeDetails.rightLensCylinder;
    return {
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.CONTACT_LENSES_BENELUX,
        typeDetails: {
            prescription: {
                rightLens: {
                    baseCurve: rightLensBaseCurve,
                    diameter: rightLensDiameter,
                    power: rightLensPower,
                    axis: rightLensAxis,
                    cylinder: rightLensCylinder,
                },
                leftLens: {
                    baseCurve: leftLensBaseCurve,
                    diameter: leftLensDiameter,
                    power: leftLensPower,
                    axis: leftLensAxis,
                    cylinder: leftLensCylinder,
                },
            },
        },
    };
};

var MAIN_LINE_ITEM_INDEX = 0;
var mapContactLensesSubscriptionLineItem = function (_a) {
    var bundleLineItems = _a.bundleLineItems, quantity = _a.quantity, typeDetails = _a.typeDetails;
    if (!bundleLineItems.every(function (item) { return Boolean(item.ratePlanId); })) {
        console.error("All of the bundleLineItems must have a ratePlanId defined.");
        return null;
    }
    return {
        sku: bundleLineItems[MAIN_LINE_ITEM_INDEX].sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION,
        bundleLineItems: bundleLineItems.map(function (item, index) {
            var _a;
            return (__assign(__assign({}, item), { type: BundleLineItemProductType[item.type.toUpperCase()], quantity: (_a = item.quantity) !== null && _a !== void 0 ? _a : 1, isMainBundleLineItem: index === MAIN_LINE_ITEM_INDEX }));
        }),
        typeDetails: __assign(__assign({}, typeDetails), { billingFrequency: BillingFrequency[typeDetails.billingFrequency.toUpperCase()], deliveryFrequency: DeliveryFrequency[typeDetails.deliveryFrequency.toUpperCase()] }),
    };
};

function getPrescriptionGlassesDetails(prescription) {
    switch (prescription.type) {
        case 'email-prescription':
            return {
                isEmailPrescription: true,
            };
        case 'existing-customer':
            return {
                isExistingCustomer: true,
            };
        case 'new-prescription':
            return {
                newPrescription: __assign({}, prescription.details),
            };
        case 'prescription-file': {
            var _a = prescription.details, prescriptionFile = _a.prescriptionFile, pupillaryDistanceFile = _a.pupillaryDistanceFile;
            return {
                prescriptionFile: {
                    fileName: prescriptionFile.fileName,
                    storageToken: prescriptionFile.storageToken,
                },
                pupillaryDistanceFile: {
                    fileName: pupillaryDistanceFile.fileName,
                    storageToken: pupillaryDistanceFile.storageToken,
                },
            };
        }
    }
}
var mapPrescriptionGlassesLineItem = function (_a) {
    var sku = _a.sku, quantity = _a.quantity, bundleLineItems = _a.bundleLineItems, prescription = _a.prescription;
    var mainBundleLineItem = {
        sku: sku,
        quantity: 1,
        isMainBundleLineItem: true,
    };
    return {
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.PRESCRIPTION_GLASSES,
        bundleLineItems: __spreadArray([
            mainBundleLineItem
        ], __read(bundleLineItems.map(function (item) {
            var _a;
            return (__assign(__assign({}, item), { quantity: (_a = item.quantity) !== null && _a !== void 0 ? _a : 1, isMainBundleLineItem: false }));
        }))),
        typeDetails: getPrescriptionGlassesDetails(prescription),
    };
};

var mapRegularLineItem = function (_a) {
    var sku = _a.sku, quantity = _a.quantity;
    return ({
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.REGULAR,
    });
};

// Map line items to the server model
var mapDraftLineItemToServer = function (lineItemDraft) {
    switch (lineItemDraft.type) {
        case 'contact-lenses':
            return mapContactLensesLineItem(lineItemDraft);
        case 'contact-lenses-bundle-benelux':
            return mapContactLensesBundleBeneluxLineItem(lineItemDraft);
        case 'contact-lenses-subscription':
            return mapContactLensesSubscriptionLineItem(lineItemDraft);
        case 'prescription-glasses':
            return mapPrescriptionGlassesLineItem(lineItemDraft);
        case 'regular':
            return mapRegularLineItem(lineItemDraft);
    }
};

var miniCartEventType = 'mini-cart';
var dispatchMiniCartEvent = function (type, lineItems) {
    if (window) {
        window.dispatchEvent(new CustomEvent(miniCartEventType, {
            detail: {
                type: type,
                lineItems: lineItems,
            },
        }));
    }
};
var useMiniCartListener = function (handler) {
    return useEventListener(miniCartEventType, handler);
};

var useAddToCart = function () {
    var intl = useIntl();
    var locale = intl.locale, currency = intl.currency, country = intl.country;
    var settings = useCartSettings();
    var _a = __read(useCartStorage(), 2), cart = _a[0], _b = _a[1], setCartId = _b.setCartId, setCartCount = _b.setCartCount;
    var _c = __read(useMutation(CREATE_CART), 2), createCart = _c[0], createCartMutation = _c[1];
    var _d = __read(useMutation(ADD_CART_LINE_ITEMS), 2), addCartLineItems = _d[0], addCartLineItemsMutation = _d[1];
    var handleOnCompleted = function (addedLineItemDrafts, data, onError, onSuccess, onValidationError) {
        var result;
        if ('addCartLineItems' in data) {
            result = data.addCartLineItems;
        }
        if ('createCart' in data) {
            result = data.createCart;
        }
        if (!result.success) {
            var validationErrors = getValidationErrorCodes(result.validationErrors);
            onValidationError && onValidationError(validationErrors);
            return;
        }
        if (!result.cart) {
            return onError(errorsMapping.CART_IS_EMPTY);
        }
        var _a = result.cart, id = _a.id, numberOfItems = _a.numberOfItems, lineItems = _a.lineItems;
        setCartId(id);
        setCartCount(numberOfItems);
        var addedLineItems = getAddedLineItems(lineItems, addedLineItemDrafts);
        var addedLineItemsMapped = lineItemDataMapper(addedLineItems, settings, intl);
        var SdProductObjects = addedLineItemsMapped.map(function (lineItem) { return createProductObject(lineItem); });
        var dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.add, addedLineItemsMapped, id);
        dataLayerEvents && DataLayer.pushEvent(dataLayerEvents);
        dispatchMiniCartEvent('added', addedLineItemsMapped);
        CartV2Actions.addToCartSdAction(SdProductObjects);
        onSuccess && onSuccess(addedLineItemsMapped);
    };
    var addToCart = React__default.useCallback(function (lineItemDrafts, onSuccess, onValidationError, onError) {
        if (onError === void 0) { onError = function () { return undefined; }; }
        return __awaiter(void 0, void 0, void 0, function () {
            var lineItems, localCartData, localStorageCartData, _a, data_1, errors;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lineItems = lineItemDrafts.map(mapDraftLineItemToServer).filter(isNotNull);
                        if (!lineItems.length) {
                            return [2 /*return*/, onError(errorsMapping.SOMETHING_WENT_WRONG)];
                        }
                        localCartData = null;
                        try {
                            localStorageCartData = window.localStorage.getItem(CART_STORAGE_KEY);
                            localCartData = isNotNull(localStorageCartData) ? JSON.parse(localStorageCartData) : null;
                        }
                        catch (err) {
                            console.error("Failed retrieving cart data from localStorage. Error: " + err);
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (isNotNull(localCartData) && isNotNull(localCartData.cartId)
                                ? addCartLineItems({
                                    variables: {
                                        cartInput: {
                                            cartId: localCartData.cartId,
                                            lineItems: lineItems,
                                        },
                                    },
                                })
                                : createCart({
                                    variables: {
                                        cartInput: {
                                            locale: locale,
                                            currency: currency,
                                            country: country,
                                            lineItems: lineItems,
                                        },
                                    },
                                }))];
                    case 2:
                        _a = _b.sent(), data_1 = _a.data, errors = _a.errors;
                        if (errors) {
                            onError(errorsMapping.SOMETHING_WENT_WRONG);
                        }
                        if (data_1) {
                            handleOnCompleted(lineItemDrafts, data_1, onError, onSuccess, onValidationError);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        onError(errorsMapping.SOMETHING_WENT_WRONG);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [cart]);
    var _e = cart.cartId
        ? addCartLineItemsMutation
        : createCartMutation, called = _e.called, loading = _e.loading, error = _e.error, data = _e.data;
    var newCart;
    if (data && 'createCart' in data) {
        newCart = data.createCart.cart;
    }
    if (data && 'addCartLineItems' in data) {
        newCart = data.addCartLineItems.cart;
    }
    return [addToCart, { called: called, loading: loading, error: error, cart: newCart }];
};

var useRemoveFromCart = function (lineItem, onSuccess) {
    var _a = __read(useCartStorage(), 2), cartId = _a[0].cartId, setCartCount = _a[1].setCartCount;
    var _b = __read(useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: function () {
            var dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.remove, [lineItem], cartId || '');
            dataLayerEvents && DataLayer.pushEvent(dataLayerEvents);
            CartV2Actions.removeLineItemsSdAction([createProductObject(lineItem)]);
            onSuccess && onSuccess();
        },
    }), 2), removeCartItems = _b[0], removeCartLineItemsMutation = _b[1];
    var removeFromCart = React__default.useCallback(function () {
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId: cartId,
                    lineItems: [
                        {
                            id: lineItem.id,
                        },
                    ],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.removeCartLineItems.success === true) {
                    var newCart = data.removeCartLineItems.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                    setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                }
            },
        });
    }, [lineItem]);
    var called = removeCartLineItemsMutation.called, loading = removeCartLineItemsMutation.loading, error = removeCartLineItemsMutation.error;
    return [removeFromCart, { called: called, loading: loading, error: error }];
};

var useUpdateLineItemQuantity = function (lineItem) {
    var _a = __read(useCartStorage(), 2), cartId = _a[0].cartId, setCartCount = _a[1].setCartCount;
    var _b = __read(React.useState(0), 2), quantityDiff = _b[0], setQuantityDiff = _b[1];
    var handleValidationErrors = function (validationErrors) {
        validationErrors.forEach(function (validationError) { return toast.failed("cart." + validationError); });
    };
    var _c = __read(useMutation(UPDATE_CART_LINE_ITEMS, {
        onCompleted: function () {
            if (quantityDiff === 0) {
                return;
            }
            var id = cartId || '';
            var eventType = quantityDiff > 0
                ? DataLayer.DataLayerTypes.EventType.add
                : DataLayer.DataLayerTypes.EventType.remove;
            var dataLayerEvents = mapLineItemToDataLayerEvent(eventType, [__assign(__assign({}, lineItem), { quantity: Math.abs(quantityDiff) })], id);
            dataLayerEvents && DataLayer.pushEvent(dataLayerEvents);
            CartV2Actions.updateQuantitySdAction([
                {
                    object: createProductObject(lineItem),
                    updateType: quantityDiff > 0 ? 'increase' : 'decrease',
                },
            ]);
        },
    }), 2), updateCartItems = _c[0], updateQuantityMutation = _c[1];
    var updateItemQuantity = React.useCallback(function (updatedQuantity) {
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        setQuantityDiff(updatedQuantity - lineItem.quantity);
        updateCartItems({
            variables: {
                cartInput: {
                    cartId: cartId,
                    lineItems: [
                        {
                            id: lineItem.id,
                            quantity: updatedQuantity,
                        },
                    ],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.updateCartLineItems.success === true) {
                    var newCart = data.updateCartLineItems.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                    setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                }
                if (data && !data.updateCartLineItems.success) {
                    var validationErrors = getValidationErrorCodes(data.updateCartLineItems.validationErrors);
                    handleValidationErrors(validationErrors);
                }
            },
        });
    }, [cartId, lineItem, setCartCount, updateCartItems]);
    var called = updateQuantityMutation.called, loading = updateQuantityMutation.loading, error = updateQuantityMutation.error;
    return [updateItemQuantity, { called: called, loading: loading, error: error }];
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useAddToCart: useAddToCart,
  useCartStorage: useCartStorage,
  useGetCart: useGetCart,
  useRemoveFromCart: useRemoveFromCart,
  useUpdateLineItemQuantity: useUpdateLineItemQuantity
});

var AddToCart$1 = function (props) { return (React.createElement(Button, __assign({ size: "custom", "data-t": "add-to-cart", className: "add-to-cart" }, props))); };

var AddToCartContainer = function (_a) {
    var lineItemDrafts = _a.lineItemDrafts, onSuccess = _a.onSuccess, buttonProps = __rest(_a, ["lineItemDrafts", "onSuccess"]);
    var onValidationError = React.useCallback(function (validationCodes) {
        validationCodes.forEach(function (code) { return toast.failed("cart." + code); });
    }, []);
    var onError = React.useCallback(function (errorCode) {
        toast.failed("cart." + errorCode);
    }, []);
    var handleSuccess = React.useCallback(function (addedLineItems) {
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(addedLineItems);
    }, [onSuccess]);
    var _b = __read(useAddToCart(), 2), addToCart = _b[0], loading = _b[1].loading;
    var handleOnClick = React.useCallback(function () { return addToCart(lineItemDrafts, handleSuccess, onValidationError, onError); }, [addToCart, lineItemDrafts, handleSuccess, onValidationError, onError]);
    if (!lineItemDrafts.length) {
        return null;
    }
    return (React.createElement(AddToCart$1, __assign({ onClick: handleOnClick, disabled: loading || buttonProps.disabled }, buttonProps)));
};

var AddToCart = function (props) { return React.createElement(AddToCartContainer, __assign({}, props)); };

var EmptyCart$1 = function (_a) {
    var labels = _a.labels, onClick = _a.onClick;
    return (React__default.createElement("div", { className: "cart", "data-t": "empty-cart" },
        React__default.createElement(Heading, { variant: "large" }, labels.cartTitle),
        React__default.createElement("div", { className: "cart__empty-message" },
            React__default.createElement(Heading, { component: "h2", variant: "small" }, labels.emptyCartTitle),
            React__default.createElement(Text, { variant: "body" }, labels.emptyCartMessage),
            React__default.createElement(Button, { className: "cart__button cart__empty-message-button", color: "primary", caption: labels.buttonCaption, onClick: onClick, "aria-label": labels.buttonCaption }))));
};

var goBack = function () {
    if (document.referrer === window.location.href) {
        window.location.href = '/';
    }
    window.location.host === document.referrer.split('/')[2]
        ? window.history.back()
        : (window.location.href = '/');
};

var EmptyCartContainer = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? goBack : _b;
    var intl = useIntl();
    var labels = useMemo(function () { return ({
        cartTitle: intl.getLabel('cart.title'),
        emptyCartTitle: intl.getLabel('cart.emptyCart.title'),
        emptyCartMessage: intl.getLabel('cart.emptyCart.message'),
        buttonCaption: intl.getLabel('cart.actions.goBack'),
    }); }, [intl.locale]);
    return React__default.createElement(EmptyCart$1, { labels: labels, onClick: onClick });
};

var EmptyCart = function (props) { return React.createElement(EmptyCartContainer, __assign({}, props)); };

var DiscountDescriptions$1 = function (_a) {
    var descriptions = _a.descriptions, labels = _a.labels;
    return (React.createElement("div", { className: "cart-totals__discount-descriptions" },
        React.createElement(Alert, { type: "info", title: labels.promotionTitle, message: descriptions, className: "cart-totals__alert" })));
};

var DiscountDescriptionsContainer = function () {
    var settings = useCartSettings();
    var cart = useCart().cart;
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        promotionTitle: getLabel('cart.cart.promotion.title'),
    }); }, [getLabel]);
    if (!settings.showCartDiscountDescriptions || !cart || !(cart.discountDescriptions.length > 0)) {
        return null;
    }
    return React.createElement(DiscountDescriptions$1, { descriptions: cart.discountDescriptions, labels: labels });
};

var DiscountDescriptions = function () { return React.createElement(DiscountDescriptionsContainer, null); };

var RemoveVoucherCodeContainer = function (_a) {
    var voucherCode = _a.voucherCode, dataT = _a["data-t"];
    var _b = __read(useMutation(REMOVE_CART_VOUCHER_CODES), 1), removeCartVoucherCodes = _b[0];
    var _c = __read(useCartStorage(), 1), cartId = _c[0].cartId;
    if (isNil(cartId) || !voucherCode) {
        return null;
    }
    var handleRemove = React.useCallback(function () {
        removeCartVoucherCodes({
            variables: {
                cartInput: {
                    cartId: cartId,
                    voucherCodes: [voucherCode],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.removeCartVoucherCodes.success === true) {
                    var newCart = data.removeCartVoucherCodes.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                }
            },
        });
    }, [cartId, removeCartVoucherCodes, voucherCode]);
    return (React.createElement("div", { className: "cart-totals__row", key: voucherCode },
        React.createElement("span", { className: "cart-totals__label" },
            React.createElement("div", { className: "cart__applied-discount" },
                React.createElement("span", { className: "cart__applied-discount-code" }, voucherCode),
                React.createElement(IconButton, { className: "cart__applied-discount-button", onClick: handleRemove, "data-t": dataT },
                    React.createElement(Icon, { className: "cart__applied-discount-icon", name: "close", width: 12, height: 12 })))),
        React.createElement("span", { className: "cart-totals__value" })));
};

var VoucherCodeFormContainer = function (_a) {
    var dataT = _a["data-t"];
    var _b = __read(useCartStorage(), 1), cartId = _b[0].cartId;
    var getLabel = useIntl().getLabel;
    if (isNil(cartId)) {
        return null;
    }
    var handleError = React.useCallback(function () {
        toast.failed('cart.validations.discountcode.notvalid');
    }, []);
    var _c = __read(useMutation(ADD_CART_VOUCHER_CODES, { onError: handleError }), 1), addCartVoucherCodes = _c[0];
    var handleSubmit = React.useCallback(function (inputValue) {
        addCartVoucherCodes({
            variables: {
                cartInput: {
                    cartId: cartId,
                    voucherCodes: [inputValue],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.addCartVoucherCodes.success === true) {
                    var newCart = data.addCartVoucherCodes.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                    toast.success('cart.validations.discountcode.matchescart');
                }
            },
        });
    }, [cartId]);
    return (React.createElement(DiscountCodeForm, { content: {
            inputField: {
                inputId: 'discount-code',
                type: 'text',
            },
        }, onSubmit: handleSubmit, placeholderLabel: getLabel('cart.discountForm.placeholder'), buttonCaptionLabel: getLabel('cart.discountForm.cta'), "data-t": dataT }));
};

var VoucherCodeForm = function () { return React.createElement(VoucherCodeFormContainer, null); };

var RemoveVoucherCode = function (props) { return (React.createElement(RemoveVoucherCodeContainer, __assign({}, props))); };

var CartDiscount = function (_a) {
    var label = _a.label, price = _a.price, currency = _a.currency;
    return (React.createElement("div", { className: "cart-totals__row" },
        React.createElement("div", { className: "cart-totals__label" },
            React.createElement(Text, { component: "span" }, label)),
        React.createElement("div", { className: "cart-totals__value cart-totals__value--discount" },
            React.createElement(Price, { value: price, currency: currency, type: "discount" }))));
};

var MainTotal = function (_a) {
    var label = _a.label, price = _a.price, currency = _a.currency;
    return (React.createElement("div", { className: "cart-totals__row" },
        React.createElement("div", { className: "cart-totals__label" },
            React.createElement(Text, { variant: "body-head", className: "cart-totals__total-price" }, label)),
        React.createElement("div", { className: "cart-totals__value" },
            React.createElement(Price, { value: price, currency: currency, className: "cart-totals__total-price" }))));
};

var PaymentMethodPrice = function (_a) {
    var label = _a.label, price = _a.price, currency = _a.currency;
    return (React.createElement("div", { className: "cart-totals__row" },
        React.createElement("div", { className: "cart-totals__label" },
            React.createElement(Text, { component: "span" }, label)),
        React.createElement("div", { className: "cart-totals__value" },
            React.createElement(Price, { value: price, currency: currency }))));
};

var Shipping = function (_a) {
    var price = _a.price, labels = _a.labels, currency = _a.currency;
    return (React.createElement("div", { className: "cart-totals__row" },
        React.createElement("div", { className: "cart-totals__label" },
            React.createElement(Text, { component: "span" }, labels.delivery)),
        React.createElement("div", { className: "cart-totals__value" }, price > 0 ? (React.createElement(Price, { value: price, currency: currency })) : (React.createElement(Text, { component: "span" }, labels.freeDelivery)))));
};

var SubscriptionExplainer = function (_a) {
    var information = _a.information;
    return (React.createElement(Text, { className: "cart-totals__subscription-explainer" }, information));
};

var SubscriptionHeader = function (_a) {
    var header = _a.header;
    return (React.createElement("div", { className: "cart-totals__subscription-header" },
        React.createElement(Divider, { theme: "light" }),
        React.createElement(Text, { className: "cart-totals__subscription-header-text", component: "span", variant: "body-head" }, header)));
};

var Subtotal = function (_a) {
    var label = _a.label, price = _a.price, currency = _a.currency;
    return (React.createElement("div", { className: "cart-totals__row" },
        React.createElement("div", { className: "cart-totals__label" },
            React.createElement(Text, { component: "span" }, label)),
        React.createElement("div", { className: "cart-totals__value" },
            React.createElement(Price, { value: price, currency: currency }))));
};

var containsOnlyContactLensesSubscriptionLineItems = function (lineItems) {
    return lineItems.every(function (lineItem) { return lineItem.type === 'contact-lenses-subscription'; });
};

var getSubscriptionLabels = function (subscriptionType, labels) {
    switch (subscriptionType) {
        case SubscriptionType.MONTHLY:
            return {
                totals: labels.totalPerMonth,
                explainer: labels.subscriptionExplainer.monthly,
            };
        case SubscriptionType.QUARTERLY:
            return {
                totals: labels.totalPerThreeMonths,
                explainer: labels.subscriptionExplainer.quarterly,
            };
        case SubscriptionType.MIXED_MONTHLY:
            return {
                totals: labels.totalPerMonth,
                explainer: labels.subscriptionExplainer.mixedMonthly,
            };
        case SubscriptionType.MIXED_QUARTERLY:
            return {
                totals: labels.totalPerThreeMonths,
                explainer: labels.subscriptionExplainer.mixedQuarterly,
            };
    }
};

var SubscriptionContainer = function (_a) {
    var lineItems = _a.lineItems, subscription = _a.subscription, hideSubscriptionExplainer = _a.hideSubscriptionExplainer;
    var _b = useIntl(), currency = _b.currency, getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var contactLensesSubscriptionLineItem = lineItems.find(function (lineItem) { return lineItem.type === 'contact-lenses-subscription'; });
    var labels = React.useMemo(function () { return ({
        totalPerMonth: getLabel('cart.subscription.totalPerMonth'),
        totalPerThreeMonths: getLabel('cart.subscription.totalPerThreeMonths'),
        firstPayment: getLabel('cart.subscription.firstPayment'),
        subscriptionExplainer: {
            monthly: getFormattedLabel('cart.subscription.explainerMonthly', {
                labelData: { billingDate: subscription.billingDate },
            }),
            quarterly: getFormattedLabel('cart.subscription.explainerQuarterly', {
                labelData: { billingDate: subscription.billingDate },
            }),
            mixedMonthly: getFormattedLabel('cart.subscription.explainerMixedMonthly', {
                labelData: { billingDate: subscription.billingDate },
            }),
            mixedQuarterly: getFormattedLabel('cart.subscription.explainerMixedQuarterly', {
                labelData: { billingDate: subscription.billingDate },
            }),
        },
    }); }, [getLabel, getFormattedLabel, subscription.billingDate]);
    if (!contactLensesSubscriptionLineItem ||
        !isContactLensesSubscriptionLineItem(contactLensesSubscriptionLineItem)) {
        return null;
    }
    var hasFirstPayment = contactLensesSubscriptionLineItem.subscriptionType === SubscriptionType.MIXED_MONTHLY;
    var _c = getSubscriptionLabels(contactLensesSubscriptionLineItem.subscriptionType, labels), totals = _c.totals, explainer = _c.explainer;
    return (React.createElement(React.Fragment, null,
        hasFirstPayment && (React.createElement(Subtotal, { label: labels.firstPayment, price: subscription.firstPayment, currency: currency })),
        React.createElement(MainTotal, { label: totals, price: subscription.recurringPayment, currency: currency }),
        !hideSubscriptionExplainer && React.createElement(SubscriptionExplainer, { information: explainer })));
};

var Mixed = function (_a) {
    var className = _a.className, currency = _a.currency, labels = _a.labels, lineItems = _a.lineItems, prices = _a.prices, settings = _a.settings, subscription = _a.subscription, voucherCodes = _a.voucherCodes, hideSubscriptionExplainer = _a.hideSubscriptionExplainer;
    return (React.createElement("div", { className: classnames('cart-totals', className) },
        settings.showSubTotal && (React.createElement(Subtotal, { label: labels.subTotal, price: prices.subTotalPrice, currency: currency })),
        settings.showTotalDiscount && prices.discountPrice !== 0 && (React.createElement(CartDiscount, { label: labels.totalDiscount, price: -prices.discountPrice, currency: currency })), voucherCodes === null || voucherCodes === void 0 ? void 0 :
        voucherCodes.map(function (code) { return (React.createElement(RemoveVoucherCode, { key: code, voucherCode: code })); }),
        prices.paymentMethodPrice && (React.createElement(PaymentMethodPrice, { label: labels.paymentMethodPrice, price: prices.paymentMethodPrice, currency: currency })),
        React.createElement(Shipping, { labels: labels, price: prices.shippingPrice, currency: currency }),
        React.createElement(MainTotal, { label: labels.todaysTotal, price: prices.totalPrice, currency: currency }),
        React.createElement(SubscriptionHeader, { header: labels.subscriptionHeader }),
        React.createElement(SubscriptionContainer, { lineItems: lineItems, subscription: subscription, hideSubscriptionExplainer: hideSubscriptionExplainer })));
};

var Regular = function (_a) {
    var className = _a.className, currency = _a.currency, labels = _a.labels, prices = _a.prices, settings = _a.settings, voucherCodes = _a.voucherCodes;
    return (React.createElement("div", { className: classnames('cart-totals', className) },
        settings.showSubTotal && (React.createElement(Subtotal, { label: labels.subTotal, price: prices.subTotalPrice, currency: currency })),
        settings.showTotalDiscount && prices.discountPrice !== 0 && (React.createElement(CartDiscount, { label: labels.totalDiscount, price: -prices.discountPrice, currency: currency })),
        voucherCodes &&
            voucherCodes.map(function (code) { return React.createElement(RemoveVoucherCode, { key: code, voucherCode: code }); }),
        prices.paymentMethodPrice && (React.createElement(PaymentMethodPrice, { label: labels.paymentMethodPrice, price: prices.paymentMethodPrice, currency: currency })),
        React.createElement(Shipping, { labels: labels, price: prices.shippingPrice, currency: currency }),
        React.createElement(MainTotal, { label: labels.total, price: prices.totalPrice, currency: currency })));
};

var Subscription = function (_a) {
    var className = _a.className, lineItems = _a.lineItems, hideSubscriptionExplainer = _a.hideSubscriptionExplainer, subscription = _a.subscription, voucherCodes = _a.voucherCodes;
    return (React.createElement("div", { className: classnames('cart-totals', className) },
        voucherCodes &&
            voucherCodes.map(function (code) { return React.createElement(RemoveVoucherCode, { key: code, voucherCode: code }); }),
        React.createElement(SubscriptionContainer, { lineItems: lineItems, subscription: subscription, hideSubscriptionExplainer: hideSubscriptionExplainer })));
};

var TotalsContainer = function (_a) {
    var showSubTotal = _a.showSubTotal, hideSubscriptionExplainer = _a.hideSubscriptionExplainer, showTotalDiscount = _a.showTotalDiscount, className = _a.className;
    var settings = useCartSettings();
    var cart = useCart().cart;
    var _b = useIntl(), currency = _b.currency, getLabel = _b.getLabel;
    var labels = React.useMemo(function () { return ({
        delivery: getLabel('cart.delivery'),
        freeDelivery: getLabel('cart.delivery.forFree'),
        subTotal: getLabel('cart.value.subTotal'),
        total: getLabel('cart.value.total'),
        todaysTotal: getLabel('cart.value.todaysTotal'),
        totalDiscount: getLabel('cart.value.totalDiscount'),
        paymentMethodPrice: getLabel('cart.value.paymentMethod'),
        subscriptionHeader: getLabel('cart.subscription.header'),
    }); }, [getLabel]);
    if (!cart) {
        return null;
    }
    var cartSettings = __assign(__assign({}, settings), { showSubTotal: !isNil(showSubTotal) ? showSubTotal : settings.showSubTotal, showTotalDiscount: !isNil(showTotalDiscount) ? showTotalDiscount : settings.showTotalDiscount });
    if (cart.subscription && containsOnlyContactLensesSubscriptionLineItems(cart.lineItems))
        return (React.createElement(Subscription, { className: className, voucherCodes: cart.voucherCodes, subscription: cart.subscription, lineItems: cart.lineItems, hideSubscriptionExplainer: hideSubscriptionExplainer }));
    if (cart.subscription)
        return (React.createElement(Mixed, { className: className, currency: currency, labels: labels, lineItems: cart.lineItems, prices: cart.prices, settings: cartSettings, hideSubscriptionExplainer: hideSubscriptionExplainer, subscription: cart.subscription, voucherCodes: cart.voucherCodes }));
    return (React.createElement(Regular, { className: className, currency: currency, labels: labels, prices: cart.prices, settings: cartSettings, voucherCodes: cart.voucherCodes }));
};

var Totals = function (props) { return React.createElement(TotalsContainer, __assign({}, props)); };

var Navigation = function (_a) {
    var labels = _a.labels, goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage;
    return (React.createElement("div", { className: "cart-navigation" },
        React.createElement(Button, { className: "cart-navigation__button", "data-t": "cart-go-back", caption: labels.goBack, variant: "outline", onClick: goToPreviousPage }),
        React.createElement(Button, { className: "cart-navigation__button", "data-t": "cart-go-to-checkout", caption: labels.goToCheckout, onClick: goToCheckout })));
};

var NavigationContainer = function (props) {
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        goBack: getLabel('cart.actions.goBack'),
        goToCheckout: getLabel('cart.actions.goToCheckout'),
    }); }, [getLabel]);
    return React.createElement(Navigation, __assign({}, props, { labels: labels }));
};

var Footer = function (_a) {
    var goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage, readOnly = _a.readOnly;
    return (React.createElement("div", { className: "cart-footer" },
        !readOnly && (React.createElement("div", { className: "cart-footer__aside" },
            React.createElement(DiscountDescriptions, null))),
        React.createElement("div", { className: "cart-footer__main" },
            !readOnly && (React.createElement("div", { className: "cart-footer__voucher-form" },
                React.createElement(VoucherCodeForm, null))),
            React.createElement(Totals, null)),
        !readOnly && (React.createElement("div", { className: "cart-footer__navigation" },
            React.createElement(NavigationContainer, { goToCheckout: goToCheckout, goToPreviousPage: goToPreviousPage })))));
};

var ContactLensMetaData = function (_a) {
    var colorLens = _a.colorLens, replacementFrequency = _a.replacementFrequency, packageQuantity = _a.packageQuantity, labels = _a.labels;
    return (React.createElement("div", { className: "line-item__contact-lens-meta" },
        colorLens && React.createElement("span", { className: "line-item__contact-lens-meta-value" }, colorLens),
        replacementFrequency && (React.createElement("span", { className: "line-item__contact-lens-meta-value" }, replacementFrequency)),
        packageQuantity && (React.createElement("span", { className: "line-item__contact-lens-meta-value" }, packageQuantity + " " + labels.productsUnitContactLenses + " " + labels.productsPerBox))));
};

var ContactLensSpecs = function (_a) {
    var specs = _a.specs, labels = _a.labels, isTabletLandscapeUp = _a.isTabletLandscapeUp;
    return (React.createElement("div", { className: "line-item__spec-box" }, specs.map(function (spec) { return (React.createElement("span", { className: "line-item__spec", key: spec.name },
        React.createElement("span", { className: "line-item__spec-label" }, isTabletLandscapeUp ? labels[spec.name] : labels[spec.name + "Abbr"]),
        React.createElement("span", { className: "line-item__spec-value" },
            spec.value,
            " "))); })));
};

var Discount = function (_a) {
    var absoluteValue = _a.absoluteValue, relativeValue = _a.relativeValue, currency = _a.currency, labels = _a.labels, className = _a.className;
    var hasAbsoluteValue = absoluteValue > 0;
    var hasRelativeValue = (relativeValue !== null && relativeValue !== void 0 ? relativeValue : 0) > 0;
    if (!hasAbsoluteValue && !hasRelativeValue) {
        return null;
    }
    return (React__default.createElement("div", { className: classnames('line-item__discount', className) },
        React__default.createElement("span", { className: "line-item__discount-text" },
            labels.discount,
            "\u00A0"),
        hasRelativeValue ? (React__default.createElement("span", { className: "line-item__discount-value" },
            relativeValue,
            "%")) : (hasAbsoluteValue && (React__default.createElement(Price, { value: absoluteValue, currency: currency, className: "line-item__discount-price", type: "discount" })))));
};

var Prices = function (_a) {
    var _b;
    var className = _a.className, currency = _a.currency, discount = _a.discount, labels = _a.labels, _c = _a.orientation, orientation = _c === void 0 ? 'vertical' : _c, originalPrice = _a.originalPrice, totalPrice = _a.totalPrice;
    return (React__default.createElement("div", { className: classnames('line-item__prices', (_b = {},
            _b["line-item__prices--" + orientation] = discount > 0,
            _b), className) },
        originalPrice !== 0 ? (React__default.createElement(Price, { value: originalPrice, currency: currency, className: classnames({
                'line-item__prices-discount-amount': discount > 0,
            }), type: discount > 0 ? 'strikethrough' : 'default' })) : (labels.freeProduct),
        discount > 0 && React__default.createElement(Price, { value: totalPrice, currency: currency, type: "discount", size: "custom" })));
};

var Image = function (_a) {
    var imageUrl = _a.imageUrl, imageAlt = _a.imageAlt;
    return (React.createElement("img", { className: "prescription-glasses-line-item-image__image", src: imageUrl, alt: imageAlt }));
};
var PrescriptionGlassesLineItemImage = function (_a) {
    var className = _a.className, href = _a.href, rest = __rest(_a, ["className", "href"]);
    var sharedProps = {
        className: classnames('prescription-glasses-line-item-image', className),
        'data-t': rest['data-t'],
    };
    return href ? (React.createElement("a", __assign({}, sharedProps, { href: href }),
        React.createElement(Image, __assign({}, rest)))) : (React.createElement("div", __assign({}, sharedProps),
        React.createElement(Image, __assign({}, rest))));
};

var SolutionSpecs = function (_a) {
    var type = _a.type, volume = _a.volume, labels = _a.labels;
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { component: "span" },
            type,
            ", "),
        React.createElement(Text, { component: "span" },
            volume,
            " ",
            labels.unit)));
};

var StockAndDelivery = function (_a) {
    var readOnly = _a.readOnly, availableQuantity = _a.availableQuantity, availability = _a.availability, deliveryResolver = _a.deliveryResolver, allowBackOrder = _a.allowBackOrder, stockResolver = _a.stockResolver, hideStockAndDeliveryOnLineItem = _a.hideStockAndDeliveryOnLineItem;
    return !readOnly && !hideStockAndDeliveryOnLineItem ? (React.createElement("div", { className: "line-item__stock-and-delivery" },
        React.createElement("div", { className: "line-item__delivery" },
            React.createElement(DeliveryIndicator, { view: "short", availability: availability ? [availability] : [], deliveryResolver: deliveryResolver })),
        React.createElement("div", { className: "line-item__stock" },
            React.createElement(StockIndicator, { allowBackOrder: allowBackOrder, stockCount: availableQuantity, stockResolver: stockResolver })))) : null;
};

var ContactLensSpecsContainer = function (_a) {
    var colorLens = _a.colorLens, replacementFrequency = _a.replacementFrequency, packageQuantity = _a.packageQuantity, specs = _a.specs;
    var getLabel = useIntl().getLabel;
    var isTabletLandscapeUp = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.TABLET_LANDSCAPE;
    var labels = React__default.useMemo(function () { return ({
        productsUnitContactLenses: getLabel('products.unit.contactLenses'),
        productsPerBox: getLabel('products.perBox'),
        baseCurve: getLabel("products.contactLenses.prescription.baseCurve"),
        baseCurveAbbr: getLabel("products.contactLenses.prescription.baseCurve.abbr"),
        diameter: getLabel("products.contactLenses.prescription.diameter"),
        diameterAbbr: getLabel("products.contactLenses.prescription.diameter.abbr"),
        axis: getLabel("products.contactLenses.prescription.axis"),
        axisAbbr: getLabel("products.contactLenses.prescription.axis.abbr"),
        power: getLabel("products.contactLenses.prescription.power"),
        powerAbbr: getLabel("products.contactLenses.prescription.power.abbr"),
        cylinder: getLabel("products.contactLenses.prescription.cylinder"),
        cylinderAbbr: getLabel("products.contactLenses.prescription.cylinder.abbr"),
        addition: getLabel("products.contactLenses.prescription.addition"),
        additionAbbr: getLabel("products.contactLenses.prescription.addition.abbr"),
    }); }, [getLabel]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ContactLensMetaData, { colorLens: colorLens, replacementFrequency: replacementFrequency, packageQuantity: packageQuantity, labels: labels }),
        React__default.createElement(ContactLensSpecs, { specs: specs, labels: labels, isTabletLandscapeUp: isTabletLandscapeUp })));
};

var DiscountContainer = function (_a) {
    var discount = _a.discount;
    var _b = useIntl(), currency = _b.currency, getLabel = _b.getLabel, locale = _b.locale;
    var settings = useCartSettings();
    var labels = React.useMemo(function () { return ({
        discount: getLabel('cart.item.discount'),
    }); }, [locale, getLabel]);
    return (React.createElement(Discount, { currency: currency, absoluteValue: discount.absoluteValue, relativeValue: settings.multiDiscountType ? discount.relativeValue : undefined, labels: labels }));
};

var PricesContainer = function (_a) {
    var className = _a.className, discount = _a.discount, orientation = _a.orientation, originalPrice = _a.originalPrice, totalPrice = _a.totalPrice;
    var _b = useIntl(), currency = _b.currency, locale = _b.locale, getLabel = _b.getLabel;
    var labels = React.useMemo(function () { return ({
        freeProduct: getLabel('products.freeProduct'),
    }); }, [locale, getLabel]);
    return (React.createElement(Prices, { className: className, currency: currency, discount: discount, orientation: orientation, originalPrice: originalPrice, totalPrice: totalPrice, labels: labels }));
};

var RemoveLineItemContainer = function (_a) {
    var lineItem = _a.lineItem;
    var _b = __read(useRemoveFromCart(lineItem), 1), removeFromCart = _b[0];
    var handleOnClick = React__default.useCallback(function () {
        removeFromCart();
    }, [lineItem]);
    return React__default.createElement(LineItemDeleteButton, { onClick: handleOnClick });
};

var SolutionSpecsContainer = function (_a) {
    var type = _a.type, volume = _a.volume;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var labels = React.useMemo(function () { return ({
        unit: getLabel('products.unit.metric.liter.milli.abbr'),
    }); }, [locale, getLabel]);
    return React.createElement(SolutionSpecs, { labels: labels, type: type, volume: volume });
};

var StockAndDeliveryContainer = function (_a) {
    var lineItem = _a.lineItem;
    var settings = useCartSettings();
    var deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory([lineItem]);
    var stockResolver = settings.stockResolverFactory && settings.stockResolverFactory(lineItem);
    var availableQuantity = Helpers.getAvailableQuantity(lineItem.availability);
    return (React.createElement(StockAndDelivery, { hideStockAndDeliveryOnLineItem: settings.hideStockAndDeliveryOnLineItem, readOnly: settings.readOnly, availableQuantity: availableQuantity, availability: lineItem.availability, deliveryResolver: deliveryResolver, allowBackOrder: isBoolean(lineItem.allowBackOrder) ? lineItem.allowBackOrder : settings.allowBackOrder, stockResolver: stockResolver }));
};

var UpdateLineItemContainer = function (_a) {
    var lineItem = _a.lineItem, availableQuantity = _a.availableQuantity;
    var _b = useCartSettings(), minimumQuantity = _b.minimumQuantity, maximumQuantity = _b.maximumQuantity;
    var _c = __read(useUpdateLineItemQuantity(lineItem), 1), updateItemQuantity = _c[0];
    var handleDecreaseQuantity = React.useCallback(function () {
        updateItemQuantity(lineItem.quantity - 1);
    }, [lineItem.quantity, updateItemQuantity]);
    var handleIncreaseQuantity = React.useCallback(function () {
        updateItemQuantity(lineItem.quantity + 1);
    }, [lineItem.quantity, updateItemQuantity]);
    return (React.createElement(QuantitySelector, { onDecreaseQuantity: handleDecreaseQuantity, onIncreaseQuantity: handleIncreaseQuantity, minimumQuantity: minimumQuantity, maximumQuantity: getCalculatedMaximumQuantity(maximumQuantity, availableQuantity), quantity: lineItem.quantity, "data-t": "quantity-selector" }));
};

var Quotation = function (_a) {
    var url = _a.url, labels = _a.labels, _b = _a.showLink, showLink = _b === void 0 ? false : _b;
    return (React__default.createElement("div", { className: "line-item-quotation" }, showLink ? (React__default.createElement("a", { className: "line-item-quotation__link", href: url },
        React__default.createElement(Icon, { name: "printer" }),
        React__default.createElement("span", null, labels.print))) : (React__default.createElement("p", { className: "line-item-quotation__label" }, labels.caption))));
};

var QuotationContainer = function (_a) {
    var type = _a.type;
    var cart = useCart().cart;
    var _b = useIntl(), locale = _b.locale, getLabel = _b.getLabel;
    var apiUrl = useApiConfig().apiUrl;
    var showDownloadLink = useQuotation().showDownloadLink;
    var isDownloadQuotationEnabled = useFeatureToggles().isDownloadQuotationEnabled;
    if (!isDownloadQuotationEnabled || !apiUrl || !(cart === null || cart === void 0 ? void 0 : cart.id)) {
        return null;
    }
    var labels = {
        caption: getLabel('products.contactLenses.quotation'),
        print: getLabel('products.contactLenses.quotationPrint'),
    };
    var downloadPdfUrl = apiUrl + "/quotes/carts/" + cart.id + "?productTypes=" + type + "&locale=" + locale;
    return React__default.createElement(Quotation, { labels: labels, url: downloadPdfUrl, showLink: showDownloadLink });
};

var ContactLenses = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var availability = lineItem.availability, productUrl = lineItem.productUrl, discount = lineItem.discount, imageUrl = lineItem.imageUrl, brand = lineItem.brand, eyeSide = lineItem.eyeSide, name = lineItem.name, isGift = lineItem.isGift, quantity = lineItem.quantity, price = lineItem.price, colorLens = lineItem.colorLens, packageQuantity = lineItem.packageQuantity, replacementFrequency = lineItem.replacementFrequency, specs = lineItem.specs;
    var iconLabel = eyeSide === 'left' ? labels.iconLeftEye : labels.iconRightEye;
    return (React.createElement(LineItem, { className: "line-item line-item--contact-lenses" },
        React.createElement("div", { className: "line-item__media" },
            React.createElement(LineItemMedia, { type: "icon", iconName: eyeSide + "-eye", iconLabel: iconLabel, href: productUrl, imageUrl: imageUrl }),
            React.createElement(LineItemMedia, { type: "image", className: "line-item__image", href: productUrl, imageUrl: imageUrl, imageAlt: brand.name + " " + brand.model })),
        React.createElement(LineItemContent, { className: "line-item__content" },
            React.createElement("div", { className: "line-item__description" },
                React.createElement(Heading, { variant: "smallest", component: "h2", className: "line-item__title" }, name)),
            React.createElement("div", { className: "line-item__quantity-and-price" },
                !readOnly && !isGift && (React.createElement("div", { className: "line-item__quantity" },
                    React.createElement("div", { className: "line-item__quantity-selector" },
                        React.createElement("div", { className: "line-item__delete-btn" },
                            React.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                        React.createElement(UpdateLineItemContainer, { lineItem: lineItem, availableQuantity: Helpers.getAvailableQuantity(availability) })))),
                React.createElement(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
            React.createElement("div", { className: "line-item__specs-and-stock" },
                React.createElement("div", { className: "line-item__specs" },
                    React.createElement(ContactLensSpecsContainer, { colorLens: colorLens, packageQuantity: packageQuantity, replacementFrequency: replacementFrequency, specs: specs })),
                React.createElement(StockAndDeliveryContainer, { lineItem: lineItem }),
                readOnly && (React.createElement("span", { className: "line-item__count" },
                    labels.quantity,
                    ": ",
                    quantity))),
            React.createElement(DiscountContainer, { discount: discount }),
            React.createElement(QuotationContainer, { type: "CONTACT_LENSES" }))));
};

var ContactLensesBundleBenelux = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var discount = lineItem.discount, imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, name = lineItem.name, lensType = lineItem.lensType, solutionImageUrl = lineItem.solutionImageUrl, solutionName = lineItem.solutionName, leftEyeProduct = lineItem.leftEyeProduct, rightEyeProduct = lineItem.rightEyeProduct, productUrl = lineItem.productUrl;
    var iconLeftEye = labels.iconLeftEye, iconRightEye = labels.iconRightEye, monthlySubscription = labels.monthlySubscription;
    return (React.createElement("div", { className: "line-item--contact-lenses-bundle-benelux" },
        React.createElement(LineItem, { className: "line-item line-item--contact-lenses-bundle-benelux-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "image", href: productUrl, imageUrl: imageUrl, imageAlt: name }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement("div", { className: "line-item__description" },
                    React.createElement(Heading, { variant: "smallest", component: "h2", className: "line-item__title" }, name),
                    React.createElement(Text, { component: "span", variant: "body" }, lensType),
                    readOnly && React.createElement(Text, { variant: "body-head" }, monthlySubscription)),
                React.createElement("div", { className: "line-item__quantity-and-price" },
                    !readOnly && !isGift && (React.createElement("div", { className: "line-item__quantity" },
                        React.createElement("div", { className: "line-item__quantity-selector" },
                            React.createElement("div", { className: "line-item__delete-btn" },
                                React.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                            React.createElement(Text, { variant: "body-head" }, monthlySubscription)))),
                    React.createElement(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
                React.createElement("div", { className: "line-item__specs-and-stock" }),
                React.createElement(DiscountContainer, { discount: discount }))),
        React.createElement(LineItem, { className: "line-item line-item--contact-lenses-bundle-benelux-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "icon", iconName: "left-eye", iconLabel: iconLeftEye }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement("div", { className: "line-item__specs-and-stock" },
                    React.createElement("div", { className: "line-item__specs" },
                        React.createElement(Text, { component: "span", variant: "body-head" }, leftEyeProduct.name),
                        React.createElement(ContactLensSpecsContainer, { specs: leftEyeProduct.specs }))))),
        React.createElement(LineItem, { className: "line-item line-item--contact-lenses-bundle-benelux-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "icon", iconName: "right-eye", iconLabel: iconRightEye }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement("div", { className: "line-item__specs-and-stock" },
                    React.createElement("div", { className: "line-item__specs" },
                        React.createElement(Text, { component: "span", variant: "body-head" }, rightEyeProduct.name),
                        React.createElement(ContactLensSpecsContainer, { specs: rightEyeProduct.specs }))))),
        solutionName && (React.createElement(LineItem, { className: "line-item line-item--contact-lenses-bundle-benelux-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "image", imageUrl: solutionImageUrl, imageAlt: solutionName }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement(Text, { variant: "body-head" }, solutionName))))));
};

var ContactLensesSubscription = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var discount = lineItem.discount, imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, name = lineItem.name, lensType = lineItem.lensType, solutionImageUrl = lineItem.solutionImageUrl, solutionName = lineItem.solutionName, leftEyeProduct = lineItem.leftEyeProduct, rightEyeProduct = lineItem.rightEyeProduct, productUrl = lineItem.productUrl, packageQuantity = lineItem.packageQuantity, billingFrequency = lineItem.billingFrequency, deliveryFrequency = lineItem.deliveryFrequency;
    var iconLeftEye = labels.iconLeftEye, iconRightEye = labels.iconRightEye, deliveredEvery = labels.deliveredEvery, perBox = labels.perBox;
    var BillingDeliveryFrequency = (React.createElement(React.Fragment, null,
        React.createElement(Text, { variant: "body-head" }, "" + billingFrequency),
        React.createElement(Text, { variant: "body" }, deliveredEvery + " " + deliveryFrequency)));
    return (React.createElement("div", { className: "line-item--contact-lenses-subscription" },
        React.createElement(LineItem, { className: "line-item line-item--contact-lenses-subscription-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "image", href: productUrl, imageUrl: imageUrl, imageAlt: name }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement("div", { className: "line-item__description" },
                    React.createElement(Heading, { variant: "smallest", component: "h2", className: "line-item__title" }, name),
                    React.createElement(Text, { component: "span", variant: "body" }, lensType + ", " + packageQuantity + " " + perBox),
                    readOnly && BillingDeliveryFrequency),
                React.createElement("div", { className: "line-item__quantity-and-price" },
                    !readOnly && !isGift && (React.createElement("div", { className: "line-item__quantity" },
                        React.createElement("div", { className: "line-item__quantity-selector" },
                            React.createElement("div", { className: "line-item__delete-btn" },
                                React.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                            React.createElement("div", { className: "line-item__frequency" }, BillingDeliveryFrequency)))),
                    React.createElement(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
                React.createElement("div", { className: "line-item__specs-and-stock" }),
                React.createElement(DiscountContainer, { discount: discount }))),
        leftEyeProduct && (React.createElement(LineItem, { className: "line-item line-item--contact-lenses-subscription-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "icon", iconName: "left-eye", iconLabel: iconLeftEye }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement("div", { className: "line-item__specs-and-stock" },
                    React.createElement("div", { className: "line-item__specs" },
                        React.createElement(ContactLensSpecsContainer, { specs: leftEyeProduct.specs })))))),
        rightEyeProduct && (React.createElement(LineItem, { className: "line-item line-item--contact-lenses-subscription-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "icon", iconName: "right-eye", iconLabel: iconRightEye }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement("div", { className: "line-item__specs-and-stock" },
                    React.createElement("div", { className: "line-item__specs" },
                        React.createElement(ContactLensSpecsContainer, { specs: rightEyeProduct.specs })))))),
        solutionName && (React.createElement(LineItem, { className: "line-item line-item--contact-lenses-subscription-item" },
            React.createElement(LineItemMedia, { className: "line-item__media", type: "image", imageUrl: solutionImageUrl, imageAlt: solutionName }),
            React.createElement(LineItemContent, { className: "line-item__content" },
                React.createElement(Text, { variant: "body-head" }, solutionName))))));
};

var classPrefix$3 = 'rx-frames-line-item';
var PrescriptionGlasses = function (_a) {
    var settings = _a.settings, lineItem = _a.lineItem, rest = __rest(_a, ["settings", "lineItem"]);
    var getLabel = useIntl().getLabel;
    var isPhone = MediaQuery.useIsPhone();
    var addOn = lineItem.addOn, currency = lineItem.currency, frame = lineItem.frame, lensType = lineItem.lensType, lensPackage = lineItem.lensPackage, name = lineItem.name, lineItemPrice = lineItem.price, prescription = lineItem.prescription, cartDiscount = lineItem.cartDiscount, productUrl = lineItem.productUrl, imageUrl = lineItem.imageUrl;
    var totalPrice = lineItemPrice.total;
    var totalDiscount = lineItemPrice.total.discount;
    var readOnly = settings.readOnly;
    var labels = React.useMemo(function () { return ({
        priceIsZero: getLabel('cart.lineItem.glasses.isIncluded', {
            hideLabelKey: true,
        }),
        lensTypeTitle: getLabel("cart.lineItem.glasses.bundleItem.LensTypes"),
        lensPackageTitle: getLabel("cart.lineItem.glasses.bundleItem.PrescriptionGlassPackages"),
        addOnTitle: getLabel("cart.lineItem.glasses.bundleItem.PrescriptionGlassPackageOptions"),
        totalDiscount: getLabel('cart.item.discount'),
    }); }, [getLabel]);
    var getBundleChildItemProps = function (bundledProduct) {
        var _a, _b, _c, _d, _e;
        return ({
            currency: currency,
            originalPrice: (_b = (_a = bundledProduct.price) === null || _a === void 0 ? void 0 : _a.original) !== null && _b !== void 0 ? _b : 0,
            discountedPrice: ((_c = bundledProduct.price) === null || _c === void 0 ? void 0 : _c.discount) ? (_d = bundledProduct.price) === null || _d === void 0 ? void 0 : _d.gross : undefined,
            priceIsZeroLabel: labels.priceIsZero,
            discountText: (_e = bundledProduct.discount) === null || _e === void 0 ? void 0 : _e.description,
            value: bundledProduct.title,
        });
    };
    return (React.createElement("div", { className: classPrefix$3, "data-t": rest['data-t'] },
        !isPhone && (React.createElement(PrescriptionGlassesLineItemImage, { imageUrl: imageUrl, href: productUrl, imageAlt: name, className: classPrefix$3 + "__image" })),
        React.createElement("div", { className: classPrefix$3 + "__content" },
            React.createElement("div", { className: classPrefix$3 + "__row" },
                React.createElement("div", { className: classPrefix$3 + "__row-item " + classPrefix$3 + "__title-wrapper" },
                    isPhone && (React.createElement(PrescriptionGlassesLineItemImage, { imageUrl: imageUrl, href: productUrl, imageAlt: name, className: classPrefix$3 + "__image" })),
                    React.createElement(Heading, { className: classPrefix$3 + "__title", variant: "smallest", component: "h3" }, name)),
                React.createElement("div", { className: classPrefix$3 + "__frame-price-wrapper" }, frame.price && (React.createElement(PricesContainer, { discount: frame.price.discount, originalPrice: frame.price.original, totalPrice: frame.price.gross, orientation: isPhone ? 'vertical' : 'horizontal' })))),
            React.createElement(LineItemGlassesPrescription, { className: classPrefix$3 + "__prescription", prescription: prescription }),
            React.createElement(PrescriptionGlassesBundleChildItem, __assign({}, getBundleChildItemProps(lensType), { label: labels.lensTypeTitle })),
            React.createElement(PrescriptionGlassesBundleChildItem, __assign({}, getBundleChildItemProps(lensPackage), { label: labels.lensPackageTitle })),
            addOn && (React.createElement(PrescriptionGlassesBundleChildItem, __assign({}, getBundleChildItemProps(addOn), { label: labels.addOnTitle }))),
            cartDiscount && cartDiscount.amount > 0 && (React.createElement("div", { className: classPrefix$3 + "__row" },
                React.createElement("div", { className: classPrefix$3 + "__row-item " + classPrefix$3 + "__cart-discount" },
                    React.createElement("span", { className: classPrefix$3 + "__cart-discount-text" }, cartDiscount.description)),
                React.createElement(Price, { value: -cartDiscount.amount, currency: currency, type: "discount" }))),
            React.createElement("div", { className: classPrefix$3 + "__row" },
                React.createElement("div", { className: classPrefix$3 + "__row-item " + classPrefix$3 + "__total-price-wrapper" },
                    !readOnly && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classPrefix$3 + "__delete-btn" },
                            React.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                        React.createElement(UpdateLineItemContainer, { lineItem: lineItem }))),
                    React.createElement(PricesContainer, { className: classPrefix$3 + "__total-price", discount: 0, originalPrice: totalPrice.gross, totalPrice: 0 }))),
            React.createElement("div", { className: classPrefix$3 + "__row" },
                React.createElement("span", { className: classPrefix$3 + "__total-discount" }, totalDiscount > 0 && (React.createElement(Discount, { absoluteValue: totalDiscount, currency: currency, labels: { discount: labels.totalDiscount } })))))));
};

var Solutions = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var availability = lineItem.availability, discount = lineItem.discount; lineItem.id; var imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, quantity = lineItem.quantity, name = lineItem.name, solutionType = lineItem.solutionType, solutionVolume = lineItem.solutionVolume;
    return (React.createElement(LineItem, { className: "line-item line-item--solutions" },
        React.createElement(LineItemMedia, { className: "line-item__media", type: "image", imageUrl: imageUrl, imageAlt: name }),
        React.createElement(LineItemContent, { className: "line-item__content" },
            React.createElement("div", { className: "line-item__description" },
                React.createElement(Heading, { variant: "smallest", component: "h2", className: "line-item__title" }, name)),
            React.createElement("div", { className: "line-item__quantity-and-price" },
                !readOnly && !isGift && (React.createElement("div", { className: "line-item__quantity" },
                    React.createElement("div", { className: "line-item__quantity-selector" },
                        React.createElement("div", { className: "line-item__delete-btn" },
                            React.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                        React.createElement(UpdateLineItemContainer, { lineItem: lineItem, availableQuantity: Helpers.getAvailableQuantity(availability) })))),
                React.createElement(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
            React.createElement("div", { className: "line-item__specs-and-stock" },
                React.createElement("div", { className: "line-item__specs" },
                    React.createElement(SolutionSpecsContainer, { type: solutionType, volume: solutionVolume })),
                React.createElement(StockAndDeliveryContainer, { lineItem: lineItem }),
                readOnly && (React.createElement("span", { className: "line-item__count" },
                    labels.quantity,
                    ": ",
                    quantity))),
            React.createElement(DiscountContainer, { discount: discount }))));
};

var Sunglasses = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var availability = lineItem.availability, brand = lineItem.brand, discount = lineItem.discount; lineItem.id; var imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, productUrl = lineItem.productUrl, quantity = lineItem.quantity, name = lineItem.name;
    return (React__default.createElement(LineItem, { className: "line-item line-item--sunglasses" },
        React__default.createElement(LineItemMedia, { className: "line-item__media", type: "image", href: productUrl, imageUrl: imageUrl, imageAlt: brand.name + " " + brand.model }),
        React__default.createElement(LineItemContent, { className: "line-item__content" },
            React__default.createElement("div", { className: "line-item__description" },
                React__default.createElement(Heading, { variant: "smallest", component: "h2", className: "line-item__title" }, name),
                React__default.createElement(Text, { component: "span", variant: "body" },
                    brand.model,
                    brand.modelCode && brand.modelCode !== brand.model ? " " + brand.modelCode : null)),
            React__default.createElement("div", { className: "line-item__quantity-and-price" },
                !readOnly && !isGift && (React__default.createElement("div", { className: "line-item__quantity" },
                    React__default.createElement("div", { className: "line-item__quantity-selector" },
                        React__default.createElement("div", { className: "line-item__delete-btn" },
                            React__default.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                        React__default.createElement(UpdateLineItemContainer, { lineItem: lineItem, availableQuantity: Helpers.getAvailableQuantity(availability) })))),
                React__default.createElement(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
            React__default.createElement("div", { className: "line-item__specs-and-stock" },
                React__default.createElement("div", { className: "line-item__specs" }),
                React__default.createElement(StockAndDeliveryContainer, { lineItem: lineItem }),
                readOnly && (React__default.createElement("span", { className: "line-item__count" },
                    labels.quantity,
                    ": ",
                    quantity))),
            React__default.createElement(DiscountContainer, { discount: discount }))));
};

var LineItemsContainer$1 = function (_a) {
    var lineItems = _a.lineItems;
    var settings = useCartSettings();
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        quantity: getLabel('cart.item.quantity'),
        iconLeftEye: getLabel('products.contactLenses.leftEye'),
        iconRightEye: getLabel('products.contactLenses.rightEye'),
        monthlySubscription: getLabel('products.monthlySubscription'),
        deliveredEvery: getLabel('cart.delivery.frequency'),
        perBox: getLabel('products.perBox'),
    }); }, [getLabel]);
    return (React.createElement(React.Fragment, null, lineItems.map(function (lineItem) {
        switch (lineItem.type) {
            case 'sunglasses':
                return (React.createElement(Sunglasses, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'prescription-glasses':
                return React.createElement(PrescriptionGlasses, { key: lineItem.id, lineItem: lineItem, settings: settings });
            case 'solutions':
                return (React.createElement(Solutions, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'contact-lenses':
                return (React.createElement(ContactLenses, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'contact-lenses-bundle-benelux':
                return (React.createElement(ContactLensesBundleBenelux, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'contact-lenses-subscription':
                return (React.createElement(ContactLensesSubscription, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            default:
                return null;
        }
    })));
};

var LineItems = function (props) { return React.createElement(LineItemsContainer$1, __assign({}, props)); };

var Cart$1 = function (_a) {
    var lineItems = _a.lineItems, cartId = _a.cartId, selectedShippingMethodKey = _a.selectedShippingMethodKey, readOnly = _a.readOnly, labels = _a.labels, deliveryResolver = _a.deliveryResolver, goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage;
    var availability = lineItems.map(function (item) { return item.availability; });
    return (React__default.createElement("div", { className: classnames('cart', { 'cart--read-only': readOnly }), "data-t": "cart" },
        React__default.createElement(Heading, { variant: "medium", component: "h1" }, labels.cartTitle),
        React__default.createElement("div", { className: "cart__content" },
            React__default.createElement(DeliveryIndicator, { availability: availability, by: "cart", cartId: cartId, deliveryResolver: deliveryResolver, selectedShippingMethodKey: selectedShippingMethodKey }),
            React__default.createElement(LineItems, { lineItems: lineItems })),
        React__default.createElement(Footer, { goToCheckout: goToCheckout, goToPreviousPage: goToPreviousPage, readOnly: readOnly })));
};

var CartContainer = function (_a) {
    var _b;
    var goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage, onEmptyCartButtonClick = _a.onEmptyCartButtonClick, showDownloadQuotePdfLink = _a.showDownloadQuotePdfLink;
    var _c = useCart(), cart = _c.cart, called = _c.called, loading = _c.loading, error = _c.error;
    var isDownloadQuotationEnabled = useFeatureToggles().isDownloadQuotationEnabled;
    var settings = useCartSettings();
    var intl = useIntl();
    var cartExists = cart !== null;
    var labels = React.useMemo(function () { return ({
        cartTitle: intl.getLabel('cart.title'),
    }); }, [intl]);
    if (cartExists && (loading || !called)) {
        return (React.createElement("div", { className: "cart", "data-t": "loading-cart" },
            React.createElement(Loader$1, null)));
    }
    var lineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems) || [];
    if (!cartExists || !cart || (!loading && (error || lineItems.length < 1))) {
        return React.createElement(EmptyCart, { onClick: onEmptyCartButtonClick });
    }
    var deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory(lineItems);
    var CartComponent = (React.createElement(Cart$1, { labels: labels, lineItems: lineItems, cartId: cart.id, selectedShippingMethodKey: (_b = cart.shippingMethod) === null || _b === void 0 ? void 0 : _b.key, goToCheckout: goToCheckout, readOnly: settings.readOnly, deliveryResolver: deliveryResolver, goToPreviousPage: goToPreviousPage }));
    if (isDownloadQuotationEnabled) {
        return (React.createElement(QuotationProvider, { showDownloadLink: showDownloadQuotePdfLink }, CartComponent));
    }
    return CartComponent;
};

var Cart = function (props) { return React.createElement(CartContainer, __assign({}, props)); };

var CartCounter = function (_a) {
    var count = _a.count;
    return (React.createElement(React.Fragment, null, count > 0 && (React.createElement("span", { className: "cart-counter", "data-t": "cart-counter" }, count))));
};

var CartButtonContainer = function () {
    var _a = __read(useCartStorage(), 2), cart = _a[0], _b = _a[1], setCartCount = _b.setCartCount, reset = _b.reset;
    var onValidationError = function (validationCodes) {
        validationCodes.forEach(function (code) { return toast.failed("cart." + code); });
    };
    var _c = __read(useLazyQuery(GET_TOTAL_LINE_ITEMS, {
        onCompleted: function (data) {
            if (!data.getCart.validationErrors) {
                setCartCount(data.getCart.cart.numberOfItems);
            }
            else {
                var validationErrorCodes = getValidationErrorCodes(data.getCart.validationErrors);
                onValidationError && onValidationError(validationErrorCodes);
                reset();
            }
        },
        onError: function () {
            reset();
        },
    }), 1), getTotalLineItems = _c[0];
    var count = useReactiveVar(cartCountVar);
    useEffect(function () {
        if (cart.cartId) {
            getTotalLineItems({
                variables: { id: cart.cartId },
            });
        }
    }, []);
    return React__default.createElement(CartCounter, { count: count });
};

var CartButton = function (_a) {
    var href = _a.href, className = _a.className, label = _a.label;
    return (React.createElement("a", { className: classnames('cart-button', className), href: href, title: label },
        React.createElement(Icon, { name: "shopping-bag" }),
        React.createElement(CartButtonContainer, null),
        label && React.createElement("span", { className: "cart-button__label" }, label)));
};

var classPrefix$2 = 'mini-cart-v2';
var ActionButtons = function (_a) {
    var buttonsRef = _a.buttonsRef, labels = _a.labels, links = _a.links, showStickyButtons = _a.showStickyButtons;
    var Buttons = (React.createElement(React.Fragment, null,
        links.cart ? (React.createElement(Button, { "aria-label": labels.toCart, caption: labels.toCart, className: classPrefix$2 + "__action-button", href: links.cart, size: "small" })) : null,
        links.checkout ? (React.createElement(Button, { "aria-label": labels.toCheckout, caption: labels.toCheckout, className: classPrefix$2 + "__action-button", href: links.checkout, size: "small", variant: "outline" })) : null));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classPrefix$2 + "__action-buttons", ref: buttonsRef }, Buttons),
        showStickyButtons ? React.createElement(StickyCallToAction, { button: Buttons }) : null));
};

var CartTotals = function () { return (React.createElement(Totals, { className: "mini-cart-v2__totals", showSubTotal: true, showTotalDiscount: true, hideSubscriptionExplainer: true })); };

var Product$1 = function (_a) {
    var body = _a.body, imageUrl = _a.imageUrl, price = _a.price, title = _a.title, quotation = _a.quotation;
    return (React.createElement(LineItem, { className: "mini-cart-v2__product" },
        React.createElement(LineItemMedia, { className: "mini-cart-v2__product--image", type: "image", imageUrl: imageUrl, imageAlt: title }),
        React.createElement(LineItemContent, { title: title, body: body }),
        React.createElement(LineItemAside, { currency: price.currency, price: price.originalPrice, discountPrice: price.discountedPrice }),
        quotation.isEnabled && (React.createElement(Text, { className: "mini-cart-v2__product--quotation", component: "p", variant: "body" }, quotation.text))));
};

var Title = function (_a) {
    var value = _a.value;
    return (React.createElement(Heading, { className: "mini-cart-v2__title", variant: "smallest" }, value));
};

var ActionButtonsContainer = function (_a) {
    var links = _a.links;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        toCart: getLabel('cart.actions.goToCart'),
        toCheckout: getLabel('cart.actions.goToCheckout'),
    }); }, [getLabel]);
    var _b = __read(useInView(), 2), buttonsRef = _b[0], buttonsInview = _b[1];
    var showStickyButtons = isSmallScreen && !buttonsInview;
    return (React.createElement(ActionButtons, { buttonsRef: buttonsRef, isSmallScreen: isSmallScreen, labels: labels, links: links, showStickyButtons: showStickyButtons }));
};

var getLineItemBody = function (lineItem, labels) {
    if (lineItem.type === 'contact-lenses') {
        var eyeSideLabel = lineItem.eyeSide === 'left' ? labels.leftEye : labels.rightEye;
        return labels.quantity + ": " + lineItem.quantity + " | " + eyeSideLabel;
    }
    if (lineItem.type === 'contact-lenses-bundle-benelux') {
        return labels.monthlySubscription;
    }
    if (lineItem.type === 'sunglasses') {
        var _a = lineItem.brand, model = _a.model, modelCode = _a.modelCode;
        return "" + model + (modelCode && modelCode !== model ? " " + modelCode : '');
    }
    if (lineItem.type === 'solutions') {
        return lineItem.solutionType + ", " + lineItem.solutionVolume + labels.unitMilli;
    }
    // TODO: Add body text for prescription glasses
    return '';
};

var LineItemsContainer = function (_a) {
    var lineItems = _a.lineItems;
    var getLabel = useIntl().getLabel;
    var isDownloadQuotationEnabled = useFeatureToggles().isDownloadQuotationEnabled;
    var labels = React.useMemo(function () { return ({
        monthlySubscription: getLabel('products.monthlySubscription'),
        quantity: getLabel('cart.item.quantity'),
        unitMilli: getLabel('products.unit.metric.liter.milli.abbr'),
        leftEye: getLabel('products.contactLenses.leftEye'),
        rightEye: getLabel('products.contactLenses.rightEye'),
        quotation: getLabel('products.contactLenses.quotationMiniCart'),
    }); }, [getLabel]);
    var products = React.useMemo(function () {
        return lineItems.map(function (lineItem) { return ({
            sku: lineItem.type === 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku,
            imageUrl: lineItem.imageUrl,
            price: {
                discountedPrice: lineItem.price.total.discount ? lineItem.price.total.gross : undefined,
                originalPrice: lineItem.price.total.original,
                currency: lineItem.currency,
            },
            title: lineItem.name,
            quotation: {
                isEnabled: lineItem.type === 'contact-lenses' && isDownloadQuotationEnabled,
                text: labels.quotation,
            },
            body: (React.createElement(Text, { component: "span", variant: "body" }, getLineItemBody(lineItem, labels))),
        }); });
    }, [lineItems, isDownloadQuotationEnabled, labels]);
    return (React.createElement(React.Fragment, null, products.map(function (product) { return (React.createElement(Product$1, __assign({ key: product.sku }, product))); })));
};

var SuccessNotificationContainer = function () {
    var intl = useIntl();
    var labels = React.useMemo(function () { return ({
        successNotification: intl.getLabel('cart.success.notification'),
    }); }, [intl]);
    return React.createElement(Alert, { icon: "checkmark", type: "success", message: labels.successNotification });
};

var TitleContainer = function () {
    var getFormattedLabel = useIntl().getFormattedLabel;
    var data = useGetCart().data;
    var value = React.useMemo(function () {
        var _a;
        return getFormattedLabel('cart.minicart.totalsTitle', {
            labelData: { numberOfItems: "" + ((_a = data === null || data === void 0 ? void 0 : data.getCart.cart.numberOfItems) !== null && _a !== void 0 ? _a : 0) },
        });
    }, [getFormattedLabel, data]);
    return React.createElement(Title, { value: value });
};

var classPrefix$1 = 'mini-cart-v2';
var MiniCart = function (_a) {
    var _b = _a.alerts, alerts = _b === void 0 ? [] : _b, children = _a.children, _c = _a.components, components = _c === void 0 ? {} : _c, links = _a.links, lineItems = _a.lineItems;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var Components = React.useMemo(function () { return ({
        ActionButtons: components.ActionButtons || ActionButtonsContainer,
        CartTotals: components.CartTotals || CartTotals,
        LineItems: components.LineItems || LineItemsContainer,
        SuccessNotification: components.SuccessNotification || SuccessNotificationContainer,
        Title: components.Title || TitleContainer,
    }); }, [components]);
    var HorizontalDivider = (React.createElement(Divider, { className: classPrefix$1 + "__divider", orientation: "horizontal", theme: "light" }));
    var childrenRenderResult = children && isFunction(children) ? children(lineItems) : children;
    if (isSmallScreen) {
        return (React.createElement(CartProvider, null,
            React.createElement(Components.Title, null),
            HorizontalDivider,
            React.createElement(Components.SuccessNotification, null),
            React.createElement(Components.LineItems, { lineItems: lineItems }),
            HorizontalDivider,
            React.createElement(Components.CartTotals, null),
            React.createElement(Components.ActionButtons, { links: links }),
            alerts.length ? React.createElement("div", { className: classPrefix$1 + "__alerts" }, alerts) : null,
            childrenRenderResult));
    }
    return (React.createElement(CartProvider, null,
        React.createElement("div", { className: classPrefix$1 + "__box" },
            React.createElement("div", { className: classPrefix$1 + "__added-item" },
                React.createElement(Components.SuccessNotification, null),
                React.createElement(Components.LineItems, { lineItems: lineItems }))),
        React.createElement(Divider, { className: classPrefix$1 + "__divider--vertical", orientation: "vertical", isFlexItem: true, theme: "light" }),
        React.createElement("div", { className: classPrefix$1 + "__box" },
            React.createElement("div", { className: classPrefix$1 + "__basket" },
                React.createElement(Components.Title, null),
                HorizontalDivider,
                React.createElement(Components.CartTotals, null),
                HorizontalDivider,
                React.createElement(Components.ActionButtons, { links: links }))),
        childrenRenderResult && (React.createElement(Divider, { className: classPrefix$1 + "__divider", orientation: "horizontal", theme: "light" })),
        alerts.length ? React.createElement("div", { className: classPrefix$1 + "__alerts" }, alerts) : null,
        childrenRenderResult));
};

var ModalContainer = function (_a) {
    var _b, _c;
    var modal = _a.modal, rest = __rest(_a, ["modal"]);
    var _d = __read(React.useState(undefined), 2), lineItems = _d[0], setLineItems = _d[1];
    useMiniCartListener(function (event) {
        if (!lineItems || event.detail.type === 'updated') {
            setLineItems(event.detail.lineItems);
        }
    });
    var handleClose = function () {
        setLineItems(undefined);
        (modal === null || modal === void 0 ? void 0 : modal.onModalClose) && modal.onModalClose();
    };
    return (React.createElement(Modal, __assign({}, modal, { className: classnames('mini-cart-v2', modal === null || modal === void 0 ? void 0 : modal.className), isOpen: (_b = (!!lineItems || (modal === null || modal === void 0 ? void 0 : modal.isOpen))) !== null && _b !== void 0 ? _b : false, onModalClose: handleClose, showIcon: (_c = modal === null || modal === void 0 ? void 0 : modal.showIcon) !== null && _c !== void 0 ? _c : true }), lineItems ? React.createElement(MiniCart, __assign({ lineItems: lineItems }, rest)) : null));
};

var MiniCartModal = function (props) {
    return React.createElement(ModalContainer, __assign({}, props));
};

var useReplaceLineItemContactLensesBundleBenelux = function () {
    var _a;
    var intl = useIntl();
    var settings = useCartSettings();
    var _b = __read(useCartStorage(), 1), cart = _b[0];
    var _c = __read(useMutation(REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM), 2), replaceCartLineItem = _c[0], replaceCartLineItemMutation = _c[1];
    var handleOnCompleted = React__default.useCallback(function (replacedLineItem, data, onSuccess, onValidationError, onError) {
        var result = data.replaceContactLensBundleBeneluxCartLineItem;
        if (!result.success) {
            var validationErrors = getValidationErrorCodes(result.validationErrors);
            onValidationError && onValidationError(validationErrors);
            return;
        }
        if (!result.cart) {
            if (onError) {
                onError(errorsMapping.CART_IS_EMPTY);
            }
            return;
        }
        var lineItemsInCart = result.cart.lineItems;
        var addedLineItems = lineItemsInCart.filter(function (_a) {
            var sku = _a.sku;
            return sku === replacedLineItem.newSku;
        });
        var addedLineItemsMappedToViewModel = lineItemDataMapper(addedLineItems, settings, intl);
        var dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.add, addedLineItemsMappedToViewModel, result.cart.id);
        dataLayerEvents && DataLayer.pushEvent(dataLayerEvents);
        dispatchMiniCartEvent('updated', addedLineItemsMappedToViewModel);
        var SdProductObjects = addedLineItemsMappedToViewModel.map(createProductObject);
        CartV2Actions.addToCartSdAction(SdProductObjects);
        onSuccess && onSuccess(addedLineItemsMappedToViewModel);
    }, [intl, settings]);
    var replaceLineItem = React__default.useCallback(function (lineItemDrafts, onSuccess, onValidationError, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data_1, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!cart.cartId) {
                        if (onError) {
                            onError(errorsMapping.MISSING_CART_ID);
                        }
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, replaceCartLineItem({
                            variables: {
                                cartInput: {
                                    cartId: cart.cartId,
                                    lineItemToReplace: lineItemDrafts,
                                },
                            },
                        })];
                case 2:
                    _a = _b.sent(), data_1 = _a.data, errors = _a.errors;
                    if (errors) {
                        if (onError) {
                            onError(errorsMapping.SOMETHING_WENT_WRONG);
                        }
                    }
                    if (data_1) {
                        handleOnCompleted(lineItemDrafts, data_1, onSuccess, onValidationError, onError);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    if (onError) {
                        onError(errorsMapping.SOMETHING_WENT_WRONG);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [cart.cartId, handleOnCompleted, replaceCartLineItem]);
    var called = replaceCartLineItemMutation.called, loading = replaceCartLineItemMutation.loading, error = replaceCartLineItemMutation.error, data = replaceCartLineItemMutation.data;
    var newCart = (_a = data === null || data === void 0 ? void 0 : data.replaceContactLensBundleBeneluxCartLineItem.cart) !== null && _a !== void 0 ? _a : null;
    return [replaceLineItem, { called: called, loading: loading, error: error, cart: newCart }];
};

var baseClassName = 'clbb-solution-picker';

var Loader = function () { return React.createElement(Loader$1, { className: baseClassName + "__loader" }); };

var Description = function (_a) {
    var value = _a.value;
    return (React.createElement("p", { className: baseClassName + "__description" }, value));
};

var DescriptionContainer = function (_a) {
    var description = _a.description;
    var locale = useIntl().locale;
    var value = description && getLocalizedValue(description, locale);
    if (!value) {
        return null;
    }
    return React.createElement(Description, { value: value });
};

var className = baseClassName + "-item";
var Solution = function (_a) {
    var _b;
    var isChecked = _a.isChecked, isLoading = _a.isLoading, onChange = _a.onChange, solution = _a.solution, title = _a.title;
    var bundleSku = solution.bundleSku, bundlePrice = solution.bundlePrice, description = solution.description, imageUrl = solution.imageUrl;
    return (React__default.createElement("div", { className: className + "__wrapper" },
        React__default.createElement(RadioButton, { isChecked: isChecked, onChange: onChange, position: "bottom", value: bundleSku, disabled: isLoading, className: classnames(className, (_b = {},
                _b[className + "--empty"] = !description && !imageUrl,
                _b)) },
            React__default.createElement("div", { className: className + "__container" },
                imageUrl && (React__default.createElement("div", { className: className + "__image-holder" },
                    React__default.createElement("img", { className: className + "__image", src: imageUrl, alt: title }))),
                React__default.createElement(Heading, { variant: "small", className: className + "__title" }, title),
                bundlePrice[0].value && (React__default.createElement("span", { className: className + "__price" },
                    React__default.createElement(Price, { value: bundlePrice[0].value.centAmount, currency: bundlePrice[0].value.currencyCode })))))));
};

var SolutionContainer = function (_a) {
    var solution = _a.solution, props = __rest(_a, ["solution"]);
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var solutionProduct = React__default.useMemo(function () {
        var _a;
        var imageUrl = isBynderImagesEnabled
            ? getFrontImage((_a = solution.media) === null || _a === void 0 ? void 0 : _a.images).url + "?w=300&auto=format"
            : solution.imageUrl;
        return __assign(__assign({}, solution), { imageUrl: imageUrl });
    }, [solution, isBynderImagesEnabled]);
    var title = solutionProduct.name
        ? getLocalizedValue(solutionProduct.name, locale)
        : getLabel('products.contactLenses.solutions.missing');
    return React__default.createElement(Solution, __assign({}, props, { solution: solutionProduct, title: title }));
};

var SolutionPicker = function (_a) {
    var activeSolution = _a.activeSolution, handleClick = _a.handleClick, isLoading = _a.isLoading, solutions = _a.solutions;
    return (React.createElement("div", { className: baseClassName },
        React.createElement("div", { className: baseClassName + "__list" }, solutions.map(function (solution) { return (React.createElement(SolutionContainer, { isChecked: activeSolution ? solution.bundleSku === activeSolution.bundleSku : false, isLoading: isLoading, key: solution.bundleSku, onChange: handleClick, solution: solution })); })),
        React.createElement(DescriptionContainer, { description: activeSolution === null || activeSolution === void 0 ? void 0 : activeSolution.description })));
};

var useFetchBundleSolutions = function (sku) {
    var productsUrl = useApiConfig().productsUrl;
    var params = React__default.useMemo(function () { return ({ sku: sku }); }, [sku]);
    var _a = __read(useApiClient(Products.getContactLensBundles, {}, productsUrl, params), 2), loading = _a[0], data = _a[1];
    return [loading, data === null || data === void 0 ? void 0 : data.solutions];
};

var ContactLensesBundleBeneluxSolutionsContainer = function (_a) {
    var subscriptionProductSku = _a.subscriptionProductSku;
    var _b = __read(React.useState(subscriptionProductSku), 2), bundleSku = _b[0], setBundleSku = _b[1];
    var _c = __read(useFetchBundleSolutions(subscriptionProductSku), 2), isFetching = _c[0], solutions = _c[1];
    var activeSolution = React.useMemo(function () { return solutions === null || solutions === void 0 ? void 0 : solutions.find(function (solution) { return solution.bundleSku === bundleSku; }); }, [bundleSku, solutions]);
    var _d = __read(useReplaceLineItemContactLensesBundleBenelux(), 2), replaceLineItem = _d[0], loading = _d[1].loading;
    var handleClick = React.useCallback(function (ev) {
        var newSku = ev.currentTarget.value;
        var existingSku = bundleSku;
        var draft = {
            newSku: newSku,
            existingSku: existingSku,
        };
        var onSuccess = function () {
            setBundleSku(newSku);
            toast.info('cart.notification.updatedCart');
        };
        var handleError = function (message) {
            var errorMessages = isArray(message) ? message : [message];
            errorMessages.forEach(function (errorMessage) { return toast.failed("cart." + errorMessage); });
        };
        replaceLineItem(draft, onSuccess, handleError, handleError);
    }, [bundleSku, replaceLineItem]);
    if (isFetching) {
        return React.createElement(Loader, null);
    }
    if (!solutions) {
        return null;
    }
    return (React.createElement(SolutionPicker, { activeSolution: activeSolution, handleClick: handleClick, isLoading: loading, solutions: solutions }));
};

var ContactLensesBundleBeneluxSolutions = function (props) {
    return React.createElement(ContactLensesBundleBeneluxSolutionsContainer, __assign({}, props));
};

var AddButton = function (props) { return (React.createElement(Button, __assign({ size: "custom", "data-t": "add-button", className: "add-button", variant: "ghost", color: "primary" }, props))); };

var AddButtonSuccessMessage = function (_a) {
    var caption = _a.caption;
    return (React.createElement("div", { className: "add-button-success-message" },
        React.createElement("span", { className: "add-button-success-message__text" }, caption)));
};

var classPrefix = 'upsell-item-product';
var Product = function (_a) {
    var body = _a.body, price = _a.price, title = _a.title, imageUrl = _a.imageUrl;
    return (React.createElement("div", { className: "" + classPrefix },
        React.createElement("div", { className: classPrefix + "__image-container" },
            React.createElement("img", { className: classPrefix + "__image", src: imageUrl + "?w=300&auto=format", alt: title })),
        React.createElement(Text, { className: classPrefix + "__title", variant: "body-head" }, title),
        body && (React.createElement(Text, { className: classPrefix + "__subtitle", variant: "caption" }, body)),
        React.createElement(PriceTag, { className: classPrefix + "__price", originalPrice: price.originalPrice, discountedPrice: price.discountedPrice, currency: price.currency })));
};

var RemoveButton = function (props) { return (React.createElement(Button, __assign({ size: "custom", "data-t": "remove-button", className: "remove-button", variant: "ghost" }, props))); };

var UpsellLayout = function (props) { return (React.createElement("div", { className: "upsell-layout" },
    React.createElement(Heading, { className: "upsell-layout__header", variant: "smallest", component: "h2" }, props.heading),
    props.children)); };

var RemoveButtonContainer = function (_a) {
    var lineItem = _a.lineItem, onSuccess = _a.onSuccess;
    var _b = __read(useRemoveFromCart(lineItem, onSuccess), 2), removeFromCart = _b[0], loading = _b[1].loading;
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        removeFromCart: getLabel('cart.actions.removeFromCart'),
    }); }, [getLabel]);
    return (React.createElement(RemoveButton, { isLoading: loading, caption: labels.removeFromCart, onClick: removeFromCart }));
};

var AddButtonContainer = function (_a) {
    var lineItemDrafts = _a.lineItemDrafts, onSuccess = _a.onSuccess;
    var getLabel = useIntl().getLabel;
    var _b = __read(useAddToCart(), 2), addToCart = _b[0], loading = _b[1].loading;
    var labels = React.useMemo(function () { return ({
        addToCart: getLabel('cart.actions.addToCart'),
    }); }, [getLabel]);
    var handOnClick = React.useCallback(function () { return addToCart(lineItemDrafts, onSuccess); }, [
        lineItemDrafts,
        onSuccess,
    ]);
    return React.createElement(AddButton, { isLoading: loading, caption: labels.addToCart, onClick: handOnClick });
};

var AddButtonSuccessMessageContainer = function () {
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        addedToCart: getLabel('cart.notification.addedToCart'),
    }); }, [getLabel]);
    return React.createElement(AddButtonSuccessMessage, { caption: labels.addedToCart });
};

var UpsellItemContainer = function (item) {
    var _a = __read(React.useState(null), 2), addedLineItem = _a[0], setAddedItem = _a[1];
    var _b = __read(React.useState(false), 2), successMessage = _b[0], setSuccessMessage = _b[1];
    var itemDraft = {
        sku: item.sku,
        quantity: 1,
        type: 'regular',
    };
    var onAddedSuccess = React.useCallback(function (_a) {
        var _b = __read(_a, 1), lineItem = _b[0];
        setSuccessMessage(true);
        setTimeout(function () {
            setSuccessMessage(false);
        }, 2000);
        setAddedItem(lineItem);
    }, [setSuccessMessage, setAddedItem]);
    var onRemovedSuccess = React.useCallback(function () {
        setAddedItem(null);
    }, [setAddedItem]);
    return (React.createElement("div", { className: classnames('upsell-item', {
            'upsell-item--is-added': addedLineItem,
        }) },
        addedLineItem && React.createElement(Icon, { name: "checkmark-circle", className: "upsell-item__checkmark" }),
        React.createElement(Product, { body: item.body, price: item.price, title: item.title, imageUrl: item.imageUrl }),
        React.createElement("div", { className: "upsell-item__action-button" },
            !addedLineItem && (React.createElement(AddButtonContainer, { lineItemDrafts: [itemDraft], onSuccess: onAddedSuccess })),
            addedLineItem && !successMessage && (React.createElement(RemoveButtonContainer, { lineItem: addedLineItem, onSuccess: onRemovedSuccess })),
            successMessage && React.createElement(AddButtonSuccessMessageContainer, null))));
};

var getPrice = function (prices) {
    if (!Array.isArray(prices) || !prices.length) {
        return undefined;
    }
    var price = prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: Currencies[price.value.currencyCode],
        };
    }
    var discounted = price.discounted;
    return {
        currency: Currencies[price.value.currencyCode],
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount,
    };
};

/**
 * From the API returned upsell data, create objects that can be processed
 * by the Upsell components
 */
var parseCTUpsellData = function (upsellProducts, locale, staticsUrl, getLabel, isBynderImagesEnabled) {
    if (!upsellProducts || upsellProducts.length === 0) {
        return [];
    }
    return upsellProducts.reduce(function (storedUpsellProducts, solution, index) {
        var _a;
        var masterVariant = solution.masterVariant, name = solution.name;
        var price = getPrice(masterVariant.prices);
        if (price === undefined || index > 3) {
            return storedUpsellProducts;
        }
        var title = getLocalizedValue(name, locale);
        var sku = (_a = masterVariant.sku) !== null && _a !== void 0 ? _a : '';
        var imageUrl = getLineItemImageUrl(masterVariant, staticsUrl, isBynderImagesEnabled);
        var solutionType = getAttrValue(masterVariant, 'solutionType');
        var volume = getAttrValue(masterVariant, 'volume');
        var availability = masterVariant.availability;
        var channelsMap = (availability === null || availability === void 0 ? void 0 : availability.channels) ? Object.entries(availability.channels) : [];
        var hasAvailableQuantity = channelsMap.some(function (_a) {
            var _b = __read(_a, 2), channel = _b[1];
            return channel.availableQuantity;
        });
        // When no availablity on product variant this item should still be orderable
        var isAvailable = !availability ? true : hasAvailableQuantity;
        if (!isAvailable) {
            return storedUpsellProducts;
        }
        var body;
        if (solutionType && volume) {
            body = solutionType + ", " + volume + getLabel('products.unit.metric.liter.milli.abbr');
        }
        var product = {
            title: title,
            body: body,
            imageUrl: imageUrl,
            sku: sku,
            price: price,
        };
        return __spreadArray(__spreadArray([], __read(storedUpsellProducts)), [product]);
    }, []);
};

var UpsellCategoryContainer = function (_a) {
    var categoryKey = _a.categoryKey;
    var productsUrl = useApiConfig().productsUrl;
    var staticsUrl = useCartSettings().staticsUrl;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var _c = __read(React.useState([]), 2), upsellProducts = _c[0], setUpsellProducts = _c[1];
    /**
     * Fetch and parse upsell products for a given category key.
     */
    var cancelled = false;
    React.useEffect(function () {
        var fetchUpsellProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, parsedProducts, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Products.query(productsUrl, {
                                categoryType: categoryKey,
                            })];
                    case 1:
                        results = (_a.sent()).results;
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        parsedProducts = parseCTUpsellData(results, locale, staticsUrl, getLabel, isBynderImagesEnabled);
                        setUpsellProducts(parsedProducts);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Error fetching upsell products " + e_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchUpsellProducts();
        return function () {
            cancelled = true;
        };
    }, [productsUrl, categoryKey, setUpsellProducts]);
    return (React.createElement(React.Fragment, null, upsellProducts.map(function (product) { return (React.createElement(UpsellItemContainer, __assign({ key: product.sku }, product))); })));
};

var UpsellCategory = function (_a) {
    var recommendedCategoryKey = _a.recommendedCategoryKey;
    return (React.createElement("div", { className: "upsell" },
        React.createElement("div", { className: "upsell__content" },
            React.createElement(UpsellCategoryContainer, { categoryKey: recommendedCategoryKey }))));
};

var UpsellProducts = function (_a) {
    var products = _a.products;
    return (React.createElement("div", { className: "upsell" },
        React.createElement("div", { className: "upsell__content" }, products.map(function (product) { return (React.createElement(UpsellItemContainer, __assign({ key: product.sku }, product))); }))));
};

var productTypeSpecificMessageLabelMapping = {
    'contact-lenses-bundle-benelux': 'cart.notification.upsell.contactLensesBundleBenelux.message',
    'contact-lenses': 'cart.notification.upsell.contactLenses.message',
    'contact-lenses-subscription': 'cart.notification.upsell.contactLensesSubscription.message',
    'prescription-glasses': 'cart.notification.upsell.prescriptionGlasses.message',
    solutions: 'cart.notification.upsell.solution.message',
    sunglasses: 'cart.notification.upsell.sunglasses.message',
};
var ProductTypeMessages = function (_a) {
    var lineItemTypes = _a.lineItemTypes;
    var getLabel = useIntl().getLabel;
    var messages = lineItemTypes
        .map(function (t) {
        return getLabel(productTypeSpecificMessageLabelMapping[t], {
            hideLabelKey: true,
        });
    })
        .filter(Boolean);
    if (messages.length <= 0) {
        return null;
    }
    return React.createElement(Alert, { message: __spreadArray([], __read(messages)) });
};
var UpsellContainer = function (_a) {
    var lineItems = _a.lineItems, products = _a.products, recommendedCategoryKey = _a.recommendedCategoryKey, subscriptionProductSku = _a.subscriptionProductSku;
    var getLabel = useIntl().getLabel;
    var labels = React.useMemo(function () { return ({
        upsellCategoryHeading: getLabel('cart.notification.productAdded'),
        clbbCategoryHeading: getLabel('products.contactLenses.solutions.title'),
    }); }, [getLabel]);
    var lineItemTypes = __spreadArray([], __read(new Set(lineItems.map(function (l) { return l.type; }))));
    if (subscriptionProductSku &&
        lineItems.some(function (lineItem) { return lineItem.type === 'contact-lenses-bundle-benelux'; })) {
        return (React.createElement(UpsellLayout, { heading: labels.clbbCategoryHeading },
            React.createElement(ProductTypeMessages, { lineItemTypes: lineItemTypes }),
            React.createElement(ContactLensesBundleBeneluxSolutions, { subscriptionProductSku: subscriptionProductSku })));
    }
    if (recommendedCategoryKey) {
        return (React.createElement(UpsellLayout, { heading: labels.upsellCategoryHeading },
            React.createElement(ProductTypeMessages, { lineItemTypes: lineItemTypes }),
            React.createElement(UpsellCategory, { recommendedCategoryKey: recommendedCategoryKey })));
    }
    if (products) {
        return (React.createElement(UpsellLayout, { heading: labels.upsellCategoryHeading },
            React.createElement(ProductTypeMessages, { lineItemTypes: lineItemTypes }),
            React.createElement(UpsellProducts, { products: products })));
    }
    return null;
};

var Upsell = function (props) { return React.createElement(UpsellContainer, __assign({}, props)); };

export { AddToCart, Cart, CartButton, index$1 as Context, EmptyCart, index as Hooks, LineItems, MiniCart, MiniCartModal, index$2 as Models, index$3 as Operations, TYPE_DETAILS_EYE_SIDE, Upsell, cartCountVar, getActiveVoucherCodes, getAddedLineItems, getAddress, getAttribute, getCalculatedMaximumQuantity, getCartPrices, getContactLensSpecs, getCustomerDetails, getDiscountDescriptions, getLineItemAvailability, getLineItemDiscount, getLineItemImageUrl, getLineItemName, getLineItemPrice, getLocalizedAttribute, getProductUrl, getShippingMethod, getSubscriptionDetails, getValidationErrorCodes, isContactLensesSubscriptionLineItem, lineItemDataMapper };
//# sourceMappingURL=index.es.js.map
